<template>
    <div class="section text-center mt-1" v-if="loading_list">
        <div class="spinner-border text-primary" role="status"></div>
    </div>
    <div class="section pt-0 mt-0" v-if="!loading_list && !this.$route.path.includes('call-follow-up-edit-v2')">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mt-1 mal-text custom-title">{{ responseData.campign.name }}</h3>
        </div>
    </div>
    <div class="section mb-1 mt-1" v-if="!loading_list && (responseData.permissions.report || responseData.permissions.can_add_mentor) && !searchResponse.contact">
        <div class="transactions">
            <a v-if="responseData.permissions.report" :href="'/#/call-follow-up-report-v2/' + responseData.campign.id" class="item compact-item">
                <div class="detail">
                    <img :src="'assets/img/telephone.png'" alt="img" class="image-block imaged w32">
                    <div>
                        <strong class="text-primary">Calling Report</strong>
                    </div>
                </div>
                <div class="right">
                    <div class="price text-primary"><ion-icon name="chevron-forward-outline"></ion-icon></div>
                </div>
            </a>
            <a v-if="responseData.permissions.can_add_mentor" href="javascript:void(0)" @click="goToMentorManagement" class="item compact-item">
                <div class="detail">
                    <img :src="'assets/img/user-star.png'" alt="img" class="image-block imaged w32" onerror="this.src='assets/img/sample/avatar/avatar1.png'">
                    <div>
                        <strong class="text-primary">Assign Mentors</strong>
                    </div>
                </div>
                <div class="right">
                    <div class="price text-primary"><ion-icon name="chevron-forward-outline"></ion-icon></div>
                </div>
            </a>
        </div>
    </div>
    <div class="section mb-1" v-if="!loading_list && !searchResponse.contact">
        <div class="row mt-1">
            <div class="col-6">
                <div class="stat-box">
                    <div class="title mal-text">ആകെ നമ്പറുകൾ</div>
                    <div class="value text-success">{{ responseData.target ? responseData.target : '0' }}</div>
                </div>
            </div>
            <div class="col-6">
                <div class="stat-box">
                    <div class="title mal-text">ബാക്കിയുള്ളത്(<a href="javascript:void(0)" data-bs-toggle="modal"
                            data-bs-target="#pendingListModel">List</a>)</div>
                    <div class="value text-danger">{{ responseData.balance ? responseData.balance : '0' }}</div>
                </div>
            </div>
        </div>
    </div>
    <div id="search" v-if="!loading_list && !this.$route.path.includes('call-follow-up-edit-v2')">
        <form class="search-form" @submit.prevent="search">
            <div class="row">
                <div class="input-group form-group" style="width:70% !important;padding-right: 0px;">
                    <input type="number" placeholder="Search Mobile..." class="form-control" maxlength="99999999999" focus
                        v-model="search_qry" aria-describedby="basic-addon3"
                        style="border: 1px solid #1a418c; border-radius: 10px;" />
                </div>
                <div class="form-group" style="width:12% !important;">
                    <button type="button" class="btn btn-icon btn-outline-success me-1" @click="search()">
                        <ion-icon name="search-outline" role="img" class="md hydrated"
                            aria-label="newspaper outline"></ion-icon>
                    </button>
                </div>
                <div class="form-group" style="width:12% !important;">
                    <button type="button" class="btn btn-icon btn-outline-primary me-1" @click="displayAll">
                        <ion-icon name="list-outline" role="img" class="md hydrated"
                            aria-label="newspaper outline"></ion-icon>
                    </button>
                </div>
            </div>
        </form>
    </div>
    <div class="section pt-0 mt-0" v-if="searchResponse.message">
        <div class="listed-detail mt-1">
            <h4 class="text-center text-danger mt-1 mal-text">{{ searchResponse.message }}</h4>
        </div>
    </div>
    <div class="section pt-0 mt-0" v-if="showContactAlternativesList && validContactsList.length > 0">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title text-warning">Available Contacts</h4>
                <p class="card-text mal-text">ആവശ്യമുള്ള കോൺടാക്ട് കണ്ടെത്താനായില്ല. ലഭ്യമായ കോൺടാക്റ്റുകൾ:</p>
            </div>
            <div class="card-body">
                <ul class="listview image-listview">
                    <li v-for="(contact, index) in validContactsList" :key="contact.id">
                        <a href="javascript:void(0)" class="item" @click="selectValidContact(contact)">
                            <span class="sl-no">{{ index + 1 }}</span>
                            <div class="in">
                                <div>
                                    <strong class="text-primary">{{ contact.name }} (ID: {{ contact.id }})</strong>
                                    <p class="text-muted">Mobile: {{ contact.mobile || 'N/A' }}</p>
                                </div>
                            </div>
                        </a>
                    </li>
                </ul>
                <button type="button" class="btn btn-secondary btn-block mt-2" @click="hideContactAlternatives">
                    Close
                </button>
            </div>
        </div>
    </div>
    <ul class="listview image-listview inset text mb-2" v-if="!loading_list && !searchResponse.contact && !search_loading">
        <li v-for="(member_list, index) in responseData.all_contacts" v-bind:key="member_list.id"
            :style="{ 'background-color': background }">
            <a href="javascript:void(0)" class="item" :class="{ 'not-clickable': isFromReport }" @click.prevent="!isFromReport && gotoEditWithData(member_list)">
                <span class="sl-no">{{ index + 1 }}</span>
                <div class="avatar-section">
                    <a href="javascript:void(0)" @click.stop>
                        <img src="assets/img/sample/avatar/avatar1.png" alt="avatar" class="image">
                        <!-- Payment Status Icon (top position) -->
                        <span v-if="shouldShowPaymentStatus() && member_list.payment_status && getPaymentStatusClass(member_list.payment_status) === 'status-badge-paid'" 
                            class="button-payment payment-verified">
                            <ion-icon name="card-outline"></ion-icon>
                        </span>
                        <!-- Self Confirmation Status Icon (bottom position) -->
                        <span v-if="member_list.self_confirmation_status && (member_list.self_confirmation_status === 'Y' || member_list.self_confirmation_status === '1' || member_list.self_confirmation_status === 1 || String(member_list.self_confirmation_status).toLowerCase().includes('confirmed'))" 
                            class="button verified">
                            <ion-icon name="checkmark-circle-outline"></ion-icon>
                        </span>
                        <!-- Completion Status Icons (fallback if status badges not shown) -->
                        <span v-if="!shouldShowStatusBadges() && member_list.status == 'Completed'" class="button verified">
                            <ion-icon name="checkmark-outline"></ion-icon>
                        </span>
                        <span v-if="!shouldShowStatusBadges() && member_list.status != 'Completed'" class="button not-verified">
                            <ion-icon name="close-outline"></ion-icon>
                        </span>
                    </a>
                </div>
                <div class="in">
                    <div class="min-width-50">
                        <!-- Registration Status as Text (Green/Red) -->
                        <header v-if="shouldShowRegistrationStatus() && member_list.registration_status" 
                            :class="(member_list.registration_status === 'Registered' || member_list.registration_status === '1' || member_list.registration_status === 1 || String(member_list.registration_status).toLowerCase().includes('registered')) ? 'text-success' : 'text-danger'">
                            {{ (member_list.registration_status === 'Registered' || member_list.registration_status === '1' || member_list.registration_status === 1 || String(member_list.registration_status).toLowerCase().includes('registered')) ? 'Registered' : 'Not Registered' }}
                        </header>
                        
                        <!-- Featured Question Display - Only show if value exists and status badges are not shown -->
                        <header v-if="hasFeaturedQuestion() && getFeaturedQuestionValue(member_list) && !shouldShowStatusBadges()" 
                            :class="getFeaturedQuestionClass(member_list)">
                            {{ getFeaturedQuestionDisplayValue(member_list) }}
                            <span v-if="member_list.self_confirmation_status == 'Y'" class="text-info">| Self Confirmed</span>
                        </header>
                        <!-- Fallback to old Registered/Not Registered logic ONLY if featured question is NOT configured and status badges are not shown -->
                        <header v-else-if="!hasFeaturedQuestion() && !shouldShowStatusBadges() && (member_list.registered == 'Y' || member_list.registered == 1 || member_list.registered == '1')" class="text-success">Registered <span v-if="member_list.self_confirmation_status == 'Y'" class="text-info">| Self Confirmed</span></header>
                        <header v-else-if="!hasFeaturedQuestion() && !shouldShowStatusBadges()" class="text-danger">Not Registered <span v-if="member_list.self_confirmation_status == 'Y'" class="text-info">| Self Confirmed</span></header>
                        <b class="text-primary"> {{ member_list.name }} -{{ member_list.mobile }} </b>
                        <footer
                            :class="member_list.calling_status_value ? member_list.calling_status_value.item_value_display : 'text-primary'">
                            {{
                                member_list.calling_status_value ? member_list.calling_status_value.name_mal :
                                member_list.calling_status
                            }}
                        </footer>

                        <!-- Activity Tracking Checkbox (per contact, date-wise) -->
                        <div
                            v-if="hasActivityTracking()"
                            class="mt-1 d-flex align-items-center activity-tracking-row"
                            style="gap: 15px;"
                            @click.stop
                        >
                            <div class="d-flex align-items-center" v-if="getActivityLabel(1)">
                                <input
                                    type="checkbox"
                                    style="width: 16px; height: 16px; margin: 0; position: relative; cursor: pointer;"
                                    v-model="member_list._activity_1"
                                    @change.stop="toggleActivity(member_list, 1)"
                                    :id="'activity_1_' + member_list.id"
                                />
                                <label class="small mal-text mb-0 ml-1 ms-1" :for="'activity_1_' + member_list.id" style="line-height: 1; padding-left: 5px; cursor: pointer;">
                                    {{ getActivityLabel(1) }}
                                </label>
                            </div>

                            <div class="d-flex align-items-center" v-if="getActivityLabel(2)">
                                <input
                                    type="checkbox"
                                    style="width: 16px; height: 16px; margin: 0; position: relative; cursor: pointer;"
                                    v-model="member_list._activity_2"
                                    @change.stop="toggleActivity(member_list, 2)"
                                    :id="'activity_2_' + member_list.id"
                                />
                                <label class="small mal-text mb-0 ml-1 ms-1" :for="'activity_2_' + member_list.id" style="line-height: 1; padding-left: 5px; cursor: pointer;">
                                    {{ getActivityLabel(2) }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </li>
    </ul>

    <!-- Edit Page with Three Card Sections -->
    <div v-if="(searchResponse.contact && !search_loading) && !form_data_loading" class="section pt-0 mt-1 pb-2">
        <!-- Profile Header: Outside the card -->
        <div class="profile-header-outside mb-2" v-if="searchResponse.contact">
            <div class="profile-header-main">
                <div class="avatar-section-compact">
                    <img v-if="searchResponse.contact.avatar && searchResponse.contact.avatar != 'member.jpg' && searchResponse.contact.avatar != null"
                        :src="'https://guide.msoftit.com/' + searchResponse.contact.avatar" 
                        alt="avatar" 
                        class="profile-avatar-compact rounded-circle">
                    <img v-else
                        src="assets/img/sample/avatar/avatar1.png" 
                        alt="avatar" 
                        class="profile-avatar-compact rounded-circle">
                </div>
                <div class="profile-info-compact">
                    <div class="profile-name-compact" v-if="isBasicFieldEnabled('b_name')">
                        {{ getBasicDisplayValue('b_name','name') || formData.b_name || formData.name || searchResponse.contact?.b_name || searchResponse.contact?.name || '-' }}
                        <span v-if="hasActualValueDifference('b_name')" class="diff-indicator ml-1" :title="'Campaign: ' + (valueDifferences['b_name']?.campaign_value || 'N/A')">
                            <ion-icon name="alert-circle-outline" class="text-warning" style="font-size: 14px;"></ion-icon>
                        </span>
                    </div>
                    <div class="profile-mobile-compact" v-if="isBasicFieldEnabled('b_mobile') && (getBasicDisplayValue('b_mobile','mobile') || formData.b_mobile || formData.mobile || searchResponse.contact?.b_mobile || searchResponse.contact?.mobile)">
                        {{ getBasicDisplayValue('b_mobile','mobile') || formData.b_mobile || formData.mobile || searchResponse.contact?.b_mobile || searchResponse.contact?.mobile }}
                    </div>
                    <!-- Reference ID: only show when campaign has this field enabled and contact has value -->
                    <div class="profile-reference-id-compact reference-id-light-red small" v-if="isBasicFieldEnabled('reference_id') && (directoryContact?.reference_id || formData.reference_id || searchResponse.contact?.reference_id)">
                        <span class="reference-id-light-red">Reference ID:</span> {{ directoryContact?.reference_id || formData.reference_id || searchResponse.contact?.reference_id }}
                    </div>
                </div>
            </div>
                    <div class="profile-header-actions">
                        <a
                            v-if="getHeaderDialNumber()"
                            :href="'tel:' + getHeaderDialNumber()"
                            class="btn btn-link btn-icon header-call-btn"
                        >
                            <ion-icon name="call-outline"></ion-icon>
                        </a>
                        <a
                            v-if="getHeaderWhatsappHref()"
                            :href="getHeaderWhatsappHref()"
                            class="btn btn-link btn-icon header-whatsapp-btn"
                        >
                            <ion-icon name="logo-whatsapp"></ion-icon>
                        </a>
                    </div>
        </div>

        <!-- Basic Details Card - Shows data from directory_contacts with value differences -->
        <div class="card mb-2">
            <div class="card-header d-flex justify-content-between align-items-center" style="padding: 8px 12px; border-bottom: 1px solid #e9ecef;">
                <h5 class="card-title mb-0" style="font-size: 16px;">Basic Details</h5>
                <button 
                    type="button" 
                    class="btn btn-sm btn-outline-primary d-flex align-items-center gap-1" 
                    @click="openEditBasicDetailsModal"
                    title="Edit Basic Details"
                >
                    <ion-icon name="create-outline" style="font-size: 16px;"></ion-icon>
                    Edit
                </button>
            </div>
            <div class="card-body basic-details-body">
                <!-- Reference ID shown in header only; not repeated here -->
                <!-- Icon + Text Grid for Other Fields -->
                <div class="basic-inline-grid">
                    <!-- Combined Age / Gender / Wing - prefer campaign-stored values then directory -->
                    <div class="form-group-compact basic-inline" v-if="(isBasicFieldEnabled('b_age') && (getBasicDisplayValue('b_age','age') || getBasicFieldValue('b_age') || formData.age || searchResponse.contact?.age || hasDirectoryValue('age'))) || (isBasicFieldEnabled('b_gender') && (getBasicDisplayValue('b_gender','gender') || getBasicFieldValue('b_gender') || formData.gender || searchResponse.contact?.gender || hasDirectoryValue('gender'))) || (isBasicFieldEnabled('b_wing') && (getBasicDisplayValue('b_wing','wing') || getBasicFieldValue('b_wing') || formData.b_wing || formData.wing || searchResponse.contact?.b_wing || searchResponse.contact?.wing || hasDirectoryValue('wing')))">
                        <ion-icon name="hourglass-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">
                            <span v-if="isBasicFieldEnabled('b_age') && (getBasicDisplayValue('b_age','age') || getBasicFieldValue('b_age') || formData.age || searchResponse.contact?.age || hasDirectoryValue('age'))">
                                {{ getBasicDisplayValue('b_age','age') || getBasicFieldValue('b_age') || formData.age || searchResponse.contact?.age || getDirectoryFieldValue('age') }}
                                <span v-if="hasActualValueDifference('b_age')" class="diff-indicator" :title="'Campaign: ' + (valueDifferences['b_age']?.campaign_value || 'N/A')">
                                    <ion-icon name="alert-circle-outline" class="text-warning" style="font-size: 12px;"></ion-icon>
                                </span>
                            </span>
                            <span v-if="isBasicFieldEnabled('b_age') && (getBasicDisplayValue('b_age','age') || getBasicFieldValue('b_age') || formData.age || searchResponse.contact?.age || hasDirectoryValue('age')) && ((isBasicFieldEnabled('b_gender') && (getBasicDisplayValue('b_gender','gender') || getBasicFieldValue('b_gender') || formData.gender || searchResponse.contact?.gender || hasDirectoryValue('gender'))) || (isBasicFieldEnabled('b_wing') && (getBasicDisplayValue('b_wing','wing') || getBasicFieldValue('b_wing') || formData.b_wing || formData.wing || searchResponse.contact?.b_wing || searchResponse.contact?.wing || hasDirectoryValue('wing'))))"> / </span>
                            <span v-if="isBasicFieldEnabled('b_gender') && (getBasicDisplayValue('b_gender','gender') || getBasicFieldValue('b_gender') || formData.gender || searchResponse.contact?.gender || hasDirectoryValue('gender'))">
                                {{ getGenderLabel(getBasicDisplayValue('b_gender','gender') || getBasicFieldValue('b_gender') || formData.gender || searchResponse.contact?.gender || getDirectoryFieldValue('gender')) }}
                            </span>
                            <span v-if="(isBasicFieldEnabled('b_gender') && (getBasicDisplayValue('b_gender','gender') || getBasicFieldValue('b_gender') || formData.gender || searchResponse.contact?.gender || hasDirectoryValue('gender'))) && (isBasicFieldEnabled('b_wing') && (getBasicDisplayValue('b_wing','wing') || getBasicFieldValue('b_wing') || formData.b_wing || formData.wing || searchResponse.contact?.b_wing || searchResponse.contact?.wing || hasDirectoryValue('wing')))"> / </span>
                            <span v-if="isBasicFieldEnabled('b_wing') && (getBasicDisplayValue('b_wing','wing') || getBasicFieldValue('b_wing') || formData.b_wing || formData.wing || searchResponse.contact?.b_wing || searchResponse.contact?.wing || hasDirectoryValue('wing'))">
                                {{ getWingLabel(getBasicDisplayValue('b_wing','wing') || getBasicFieldValue('b_wing') || formData.b_wing || formData.wing || searchResponse.contact?.b_wing || searchResponse.contact?.wing || getDirectoryFieldValue('wing')) }}
                            </span>
                        </span>
                    </div>

                    <!-- Membership Status: only show after directory contact loaded to avoid flash of "Not Member" -->
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_membership_status') && directoryContact">
                        <ion-icon name="card-outline" class="basic-inline-icon"></ion-icon>
                        <div
                            class="membership-badge"
                            :class="displayMembershipLabel === 'Member' ? 'text-success' : 'text-danger'"
                        >
                            {{ displayMembershipLabel }}
                        </div>
                    </div>

                    <!-- WhatsApp -->
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_whatsapp') && (getBasicDisplayValue('b_whatsapp','whatsapp') || getDirectoryFieldValue('whatsapp') || getBasicFieldValue('b_whatsapp') || formData.whatsapp || searchResponse.contact?.whatsapp)">
                        <ion-icon name="logo-whatsapp" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">
                            {{ getBasicDisplayValue('b_whatsapp','whatsapp') || getDirectoryFieldValue('whatsapp') || getBasicFieldValue('b_whatsapp') || formData.whatsapp || searchResponse.contact?.whatsapp }}
                            <span v-if="hasActualValueDifference('b_whatsapp')" class="diff-indicator" :title="'Campaign: ' + (valueDifferences['b_whatsapp']?.campaign_value || 'N/A')">
                                <ion-icon name="alert-circle-outline" class="text-warning" style="font-size: 12px;"></ion-icon>
                            </span>
                        </span>
                    </div>

                    <!-- Job -->
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_job') && (getBasicDisplayValue('b_job','job') || getDirectoryFieldValue('job') || getBasicFieldValue('b_job') || formData.job || searchResponse.contact?.job)">
                        <ion-icon name="briefcase-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">
                            {{ searchResponse.contact?.b_job || searchResponse.contact?.b_job_name || getBasicFieldValue('b_job') || formData.job || searchResponse.contact?.job || directoryContact?.job_name || getDirectoryFieldValue('job') }}
                            <span v-if="hasActualValueDifference('b_job')" class="diff-indicator" :title="'Campaign: ' + (valueDifferences['b_job']?.campaign_value || 'N/A')">
                                <ion-icon name="alert-circle-outline" class="text-warning" style="font-size: 12px;"></ion-icon>
                            </span>
                        </span>
                    </div>

                    <!-- Member ID -->
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_member_id') && (getBasicFieldValue('b_member_id') || formData.member_id || searchResponse.contact?.member_id)">
                        <ion-icon name="id-card-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">{{ getBasicFieldValue('b_member_id') || formData.member_id || searchResponse.contact?.member_id }}</span>
                    </div>

                    <!-- Current Place -->
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_place') && (getBasicDisplayValue('b_place','place') || getDirectoryFieldValue('place') || getBasicFieldValue('b_place') || formData.place || searchResponse.contact?.place)">
                        <ion-icon name="home-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">
                            {{ getBasicDisplayValue('b_place','place') || getDirectoryFieldValue('place') || getBasicFieldValue('b_place') || formData.place || searchResponse.contact?.place }}
                            <span v-if="hasActualValueDifference('b_place')" class="diff-indicator" :title="'Campaign: ' + (valueDifferences['b_place']?.campaign_value || 'N/A')">
                                <ion-icon name="alert-circle-outline" class="text-warning" style="font-size: 12px;"></ion-icon>
                            </span>
                        </span>
                    </div>

                    <!-- District -->
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_district') && (getBasicDisplayNameDistrictZoneUnit('district') || getDirectoryFieldDisplayName('district') || getDistrictName(getBasicFieldValue('b_district') || formData.district_id || searchResponse.contact?.district_id))">
                        <ion-icon name="map-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">
                            {{ getBasicDisplayNameDistrictZoneUnit('district') || getDirectoryFieldDisplayName('district') || getDistrictName(getBasicFieldValue('b_district') || formData.district_id || searchResponse.contact?.district_id) }}
                            <span v-if="hasActualValueDifference('b_district')" class="diff-indicator">
                                <ion-icon name="alert-circle-outline" class="text-warning" style="font-size: 12px;"></ion-icon>
                            </span>
                        </span>
                    </div>

                    <!-- Zone -->
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_zone') && (getBasicDisplayNameDistrictZoneUnit('zone') || getDirectoryFieldDisplayName('zone') || getZoneName(getBasicFieldValue('b_zone') || formData.zone_id || searchResponse.contact?.zone_id))">
                        <ion-icon name="navigate-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">
                            {{ getBasicDisplayNameDistrictZoneUnit('zone') || getDirectoryFieldDisplayName('zone') || getZoneName(getBasicFieldValue('b_zone') || formData.zone_id || searchResponse.contact?.zone_id) }}
                            <span v-if="hasActualValueDifference('b_zone')" class="diff-indicator">
                                <ion-icon name="alert-circle-outline" class="text-warning" style="font-size: 12px;"></ion-icon>
                            </span>
                        </span>
                    </div>

                    <!-- Unit -->
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_unit') && (getBasicDisplayNameDistrictZoneUnit('unit') || getDirectoryFieldDisplayName('unit') || getUnitName(getBasicFieldValue('b_unit') || formData.unit_id || searchResponse.contact?.unit_id))">
                        <ion-icon name="business-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">
                            {{ getBasicDisplayNameDistrictZoneUnit('unit') || getDirectoryFieldDisplayName('unit') || getUnitName(getBasicFieldValue('b_unit') || formData.unit_id || searchResponse.contact?.unit_id) }}
                            <span v-if="hasActualValueDifference('b_unit')" class="diff-indicator">
                                <ion-icon name="alert-circle-outline" class="text-warning" style="font-size: 12px;"></ion-icon>
                            </span>
                        </span>
                    </div>

                    <!-- Education -->
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_education') && (getBasicDisplayValue('b_education','education') || getDirectoryFieldValue('education') || getBasicFieldValue('b_education') || formData.education || searchResponse.contact?.education || searchResponse.contact?.b_education)">
                        <ion-icon name="school-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">
                            {{ searchResponse.contact?.b_education_name || searchResponse.contact?.education_name || getBasicFieldValue('b_education') || formData.education || searchResponse.contact?.education || searchResponse.contact?.b_education || directoryContact?.education_name || getDirectoryFieldValue('education') }}
                            <span v-if="hasActualValueDifference('b_education')" class="diff-indicator">
                                <ion-icon name="alert-circle-outline" class="text-warning" style="font-size: 12px;"></ion-icon>
                            </span>
                        </span>
                    </div>

                    <!-- Institution -->
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_institution') && (getBasicDisplayValue('b_institution','institution') || getDirectoryFieldValue('institution') || getBasicFieldValue('b_institution') || formData.institution || searchResponse.contact?.institution)">
                        <ion-icon name="library-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">
                            {{ getBasicDisplayValue('b_institution','institution') || getDirectoryFieldValue('institution') || getBasicFieldValue('b_institution') || formData.institution || searchResponse.contact?.institution }}
                            <span v-if="hasActualValueDifference('b_institution')" class="diff-indicator">
                                <ion-icon name="alert-circle-outline" class="text-warning" style="font-size: 12px;"></ion-icon>
                            </span>
                        </span>
                    </div>

                    <!-- Background -->
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_background') && (getBasicDisplayValue('b_background','background') || getDirectoryFieldValue('background') || getBasicFieldValue('b_background') || formData.background || formData.background_summery || searchResponse.contact?.background || searchResponse.contact?.background_summery)">
                        <ion-icon name="information-circle-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">{{ getBasicDisplayValue('b_background','background') || getDirectoryFieldValue('background') || getBasicFieldValue('b_background') || formData.background || formData.background_summery || searchResponse.contact?.background || searchResponse.contact?.background_summery }}</span>
                    </div>

                    <!-- Org Positions (read-only display) -->
                    <div class="form-group-compact basic-inline basic-inline-full" v-if="isBasicFieldEnabled('b_org_positions') && isMember && (getDirectoryFieldValue('org_positions') || getBasicFieldValue('b_org_positions'))">
                        <ion-icon name="medal-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text" style="word-break: break-word; line-height: 1.4;">{{ getDirectoryFieldValue('org_positions') || getBasicFieldValue('b_org_positions') }}</span>
                    </div>

                    <!-- Org Departments (read-only display) -->
                    <div class="form-group-compact basic-inline basic-inline-full" v-if="isBasicFieldEnabled('b_org_departments') && isMember && (getDirectoryFieldValue('org_departments') || getBasicFieldValue('b_org_departments'))">
                        <ion-icon name="git-network-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text" style="word-break: break-word; line-height: 1.4;">{{ getDirectoryFieldValue('org_departments') || getBasicFieldValue('b_org_departments') }}</span>
                    </div>

                    <!-- Additional fields: only show when enabled in campaign -->
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_native_place') && (getBasicDisplayValue('b_native_place','native_place') || (directoryContact && directoryContact.native_place))">
                        <ion-icon name="location-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">Native: {{ getBasicDisplayValue('b_native_place','native_place') || (directoryContact && directoryContact.native_place) }}</span>
                    </div>
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_diabetic') && (getBasicDisplayValue('b_diabetic','diabetic') || (directoryContact && directoryContact.diabetic))">
                        <ion-icon name="fitness-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">Diabetic: {{ getBasicDisplayValue('b_diabetic','diabetic') || (directoryContact && directoryContact.diabetic) }}</span>
                    </div>
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_disability') && (getBasicDisplayValue('b_disability','disability') || (directoryContact && directoryContact.disability))">
                        <ion-icon name="accessibility-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">Disability: {{ getBasicDisplayValue('b_disability','disability') || (directoryContact && directoryContact.disability) }}</span>
                    </div>
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_pr_listener') && (getBasicDisplayValue('b_pr_listener','pr_listener') || (directoryContact && directoryContact.pr_listener))">
                        <ion-icon name="radio-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">PR Listener: {{ getBasicDisplayValue('b_pr_listener','pr_listener') || (directoryContact && directoryContact.pr_listener) }}</span>
                    </div>
                    <div class="form-group-compact basic-inline" v-if="isBasicFieldEnabled('b_category') && (getBasicDisplayValue('b_category','category') || (directoryContact && directoryContact.category))">
                        <ion-icon name="pricetag-outline" class="basic-inline-icon"></ion-icon>
                        <span class="basic-inline-text">Category: {{ getBasicDisplayValue('b_category','category') || (directoryContact && directoryContact.category) }}</span>
                    </div>
                </div>
                
                <!-- Value Differences Section - collapsible -->
                <div v-if="Object.keys(filteredValueDifferences).length > 0" class="value-differences-section mt-2">
                    <div class="diff-header diff-header-clickable" @click="callAndConfirmCollapsed = !callAndConfirmCollapsed" role="button" :aria-expanded="!callAndConfirmCollapsed">
                        <ion-icon name="swap-horizontal-outline" class="diff-header-icon"></ion-icon>
                        <span class="diff-header-text">Call and Confirm</span>
                        <ion-icon :name="callAndConfirmCollapsed ? 'chevron-down-outline' : 'chevron-up-outline'" class="diff-header-chevron ml-auto"></ion-icon>
                    </div>
                    <div v-show="!callAndConfirmCollapsed" class="diff-list">
                        <div v-for="(diff, field) in filteredValueDifferences" :key="field" class="diff-item">
                            <div class="diff-field-name">{{ getFieldLabel(field) }}</div>
                            <div class="diff-values">
                                <div class="diff-value-row">
                                    <span class="diff-source-label">{{ getDiffSourceLabel(field, 1) }}</span>
                                    <span class="diff-value text-primary">{{ getDisplayValueForDiff(field, diff.directory_value ?? getDirectoryValueForDiffField(field)) || 'N/A' }}</span>
                                </div>
                                <div class="diff-value-row">
                                    <span class="diff-source-label">{{ getDiffSourceLabel(field, 2) }}</span>
                                    <span class="diff-value text-muted">{{ getDisplayValueForDiff(field, diff.campaign_value) || 'N/A' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Additional Info: only show when campaign has this field enabled and contact has value -->
                <div class="form-group-compact basic-inline basic-inline-full mt-1 pt-1" v-if="isBasicFieldEnabled('additional_info') && (directoryContact?.additional_info || formData.additional_info || searchResponse.contact?.additional_info)">
                    <ion-icon name="information-circle-outline" class="basic-inline-icon"></ion-icon>
                    <span class="basic-inline-text" style="word-break: break-word; white-space: pre-wrap;">{{ directoryContact?.additional_info || formData.additional_info || searchResponse.contact?.additional_info }}</span>
                </div>
            </div>
        </div>

        <!-- Survey / History Tabs -->
        <div class="section mt-1 mb-1 detail-tabs-wrapper">
            <ul class="nav nav-tabs lined detail-tabs" role="tablist">
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: activeDetailTab === 'survey' }"
                        href="javascript:void(0)"
                        role="tab"
                        @click="setDetailTab('survey')"
                    >
                        Survey
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: activeDetailTab === 'history' }"
                        href="javascript:void(0)"
                        role="tab"
                        @click="setDetailTab('history')"
                    >
                        History
                    </a>
                </li>
            </ul>
        </div>

        <!-- Survey Card (Survey Tab) -->
        <div class="card mb-2" v-if="activeDetailTab === 'survey'">
            <div class="card-body">
                <Form @submit="handleRegistration" ref="veeForm">
                    <div class="form-group basic" v-for="field in enabledFields" :key="field.id">
                        <div class="input-wrapper">
                            <label class="label text-primary" :for="field.column_id">
                                {{ field.label }}
                                <span class="text-danger" v-if="field.required">*</span>
                            </label>
                            <template v-if="field.type === 'Select'">
                                <select
                                    class="form-control custom-select"
                                    :name="field.column_id"
                                    v-model="formData[field.column_id]"
                                    :required="field.required"
                                >
                                    <option value="">--select--</option>
                                    <option v-for="option in getFieldOptions(field)" :key="option.value" :value="option.value">
                                        {{ option.label }}
                                    </option>
                                </select>
                            </template>
                            <template v-else-if="field.type === 'Radio'">
                                <div class="radio-group">
                                    <div v-for="option in getFieldOptions(field)" :key="option.value" class="form-check">
                                        <input
                                            type="radio"
                                            class="form-check-input"
                                            :id="field.column_id + '_' + option.value"
                                            :name="field.column_id"
                                            :value="option.value"
                                            v-model="formData[field.column_id]"
                                            :required="field.required"
                                        />
                                        <label :for="field.column_id + '_' + option.value" class="form-check-label">
                                            {{ option.label }}
                                        </label>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="field.type === 'Checkbox'">
                                <div class="checkbox-group">
                                    <div v-for="option in getFieldOptions(field)" :key="option.value" class="form-check">
                                        <input
                                            type="checkbox"
                                            class="form-check-input"
                                            :id="field.column_id + '_' + option.value"
                                            :name="field.column_id + '_' + option.value"
                                            :value="option.value"
                                            :checked="isCheckboxChecked(field.column_id, option.value)"
                                            @change="handleCheckboxChange(field.column_id, option.value, $event)"
                                            :required="field.required"
                                        />
                                        <label :for="field.column_id + '_' + option.value" class="form-check-label">
                                            {{ option.label }}
                                        </label>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="field.type === 'textarea'">
                                <textarea
                                    class="form-control"
                                    :name="field.column_id"
                                    v-model="formData[field.column_id]"
                                    :placeholder="field.label"
                                    :required="field.required"
                                ></textarea>
                            </template>
                            <template v-else>
                                <input
                                    :type="field.type === 'Number' ? 'number' : field.type === 'time' ? 'time' : field.type === 'datetime-local' ? 'datetime-local' : 'text'"
                                    class="form-control"
                                    :name="field.column_id"
                                    v-model="formData[field.column_id]"
                                    :placeholder="field.label"
                                    :required="field.required"
                                    autocomplete="off"
                                />
                            </template>
                            <span class="error-feedback" v-if="field.required && !formData[field.column_id]" style="display: none;">
                                This field is required
                            </span>
                        </div>
                    </div>

                    <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="btn_loading">
                        <span v-show="btn_loading" class="spinner-border spinner-border-sm"></span>
                        <span>Save</span>
                    </button>
                </Form>
            </div>
        </div>

        <!-- History Card (History Tab) -->
        <div class="card mb-2" v-if="activeDetailTab === 'history'">
            <div class="card-body call-history-card">
                <div class="call-history-header">
                    <span class="call-history-title">Call History</span>
                </div>

                <div v-if="callHistoryList && callHistoryList.length">
                    <ul class="call-history-list">
                        <li v-for="(item, index) in callHistoryList" :key="index" class="call-history-item">
                            <div class="call-history-timeline">
                                <span class="call-history-dot" :class="{ 'active': index === 0 }"></span>
                                <span
                                    v-if="index !== callHistoryList.length - 1"
                                    class="call-history-line"
                                ></span>
                            </div>
                            <div class="call-history-content">
                                <div class="call-history-entry">
                                    <div class="call-history-entry-header">
                                        <div class="call-history-main">
                                            {{ formatCallHistoryMain(item) }}
                                        </div>
                                        <div class="call-history-duration" v-if="item.duration">
                                            {{ item.duration }}
                                        </div>
                                        <ion-icon name="chevron-down-outline" class="call-history-chevron"></ion-icon>
                                    </div>

                                    <div class="call-history-meta" v-if="formatCallHistoryMeta(item) || item.caller">
                                        <span v-if="item.caller">Caller: {{ item.caller }}</span>
                                        <span v-if="formatCallHistoryMeta(item)" class="dot-separator">
                                            {{ formatCallHistoryMeta(item) }}
                                        </span>
                                    </div>

                                    <div class="call-history-section" v-if="item.conversation_log">
                                        <span class="call-history-section-label">Conversation Log:</span>
                                        <span class="call-history-section-text">{{ item.conversation_log }}</span>
                                    </div>

                                    <div class="call-history-section" v-if="item.notes">
                                        <span class="call-history-section-label">Notes:</span>
                                        <span class="call-history-section-text">{{ item.notes }}</span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <div v-else class="text-center py-2">
                    <p class="text-muted mb-0">No previous call history available.</p>
                </div>
            </div>
        </div>
    </div>

    <!-- Edit Basic Details Action Sheet (Bottom Sheet) -->
    <div class="modal fade action-sheet" id="editBasicDetailsModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Edit Basic Details</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <form @submit.prevent="submitBasicDetailsEdit" class="edit-basic-form">
                            <div class="form-group basic" v-for="field in filteredEditableBasicFields" :key="field.column_id">
                                <label :for="'edit_' + field.column_id" class="label">
                                    {{ field.label }}
                                    <span class="text-danger" v-if="field.required">*</span>
                                </label>
                                
                                <!-- Value Difference Selector - Show only when the two values actually differ -->
                                <div v-if="hasActualValueDifference(field.column_id)" class="diff-selector mb-1">
                                    <div class="diff-selector-header">
                                        <ion-icon name="swap-horizontal-outline" style="font-size: 14px; color: #f0ad4e;"></ion-icon>
                                        <span class="diff-selector-text">Values differ - select correct one:</span>
                                    </div>
                                    <div class="diff-selector-options">
                                        <label class="diff-option" :class="{ 'selected': confirmedValues[field.column_id] === 'directory' }">
                                            <input type="radio" :name="'diff_' + field.column_id" value="directory" v-model="confirmedValues[field.column_id]" @input="onDiffValueSelected(field.column_id, 'directory')" @change="onDiffValueSelected(field.column_id, 'directory')">
                                            <span class="diff-option-label">{{ getDiffSourceLabel(field.column_id, 1) }}</span>
                                            <span class="diff-option-value text-primary">{{ getDisplayValueForDiff(field.column_id, valueDifferences[field.column_id]?.directory_value ?? getDirectoryValueForDiffField(field.column_id)) || 'N/A' }}</span>
                                        </label>
                                        <label class="diff-option" :class="{ 'selected': confirmedValues[field.column_id] === 'campaign' }">
                                            <input type="radio" :name="'diff_' + field.column_id" value="campaign" v-model="confirmedValues[field.column_id]" @input="onDiffValueSelected(field.column_id, 'campaign')" @change="onDiffValueSelected(field.column_id, 'campaign')">
                                            <span class="diff-option-label">{{ getDiffSourceLabel(field.column_id, 2) }}</span>
                                            <span class="diff-option-value text-muted">{{ getDisplayValueForDiff(field.column_id, valueDifferences[field.column_id]?.campaign_value) || 'N/A' }}</span>
                                        </label>
                                    </div>
                                </div>
                                
                                <!-- Readonly fields: Mobile, Membership Status, and District/Zone/Unit for members -->
                                <div class="input-wrapper" v-if="isFieldReadonly(field.column_id)">
                                    <input 
                                        type="text"
                                        :id="'edit_' + field.column_id"
                                        class="form-control"
                                        :value="getReadonlyDisplayValue(field.column_id)"
                                        readonly
                                        disabled
                                        style="background-color: #f5f5f5; color: #888;"
                                    />
                                </div>
                                
                                <!-- Select Field (district/zone/unit: show stored name directly in dropdown when no org ID match) -->
                                <div class="input-wrapper" v-else-if="field.type === 'Select'">
                                    <select 
                                        :id="'edit_' + field.column_id"
                                        class="form-control custom-select"
                                        v-model="editBasicFormData[field.column_id]"
                                        :required="field.required"
                                        @change="handleEditDistrictZoneChange(field.column_id, $event)"
                                    >
                                        <option value="">--select--</option>
                                        <option v-for="option in getFieldOptions(field)" :key="option.value" :value="option.value">
                                            {{ option.label }}
                                        </option>
                                    </select>
                                </div>
                                
                                <!-- Radio Field -->
                                <div v-else-if="field.type === 'Radio'" class="edit-radio-group">
                                    <div v-for="option in getFieldOptions(field)" :key="option.value" class="edit-radio-item">
                                        <input
                                            type="radio"
                                            class="edit-radio-input"
                                            :id="'edit_' + field.column_id + '_' + option.value"
                                            :name="'edit_' + field.column_id"
                                            :value="option.value"
                                            v-model="editBasicFormData[field.column_id]"
                                            :required="field.required"
                                        />
                                        <label :for="'edit_' + field.column_id + '_' + option.value" class="edit-radio-label">
                                            {{ option.label }}
                                        </label>
                                    </div>
                                </div>
                                
                                <!-- Number Field -->
                                <div class="input-wrapper" v-else-if="field.type === 'Number'">
                                    <input 
                                        type="number"
                                        :id="'edit_' + field.column_id"
                                        class="form-control"
                                        v-model="editBasicFormData[field.column_id]"
                                        :placeholder="field.label"
                                        :required="field.required"
                                    />
                                </div>
                                
                                <!-- Textarea Field -->
                                <div class="input-wrapper" v-else-if="field.type === 'textarea'">
                                    <textarea 
                                        :id="'edit_' + field.column_id"
                                        class="form-control"
                                        v-model="editBasicFormData[field.column_id]"
                                        :placeholder="field.label"
                                        :required="field.required"
                                        rows="3"
                                    ></textarea>
                                </div>
                                
                                <!-- Text Field (default) -->
                                <div class="input-wrapper" v-else>
                                    <input 
                                        type="text"
                                        :id="'edit_' + field.column_id"
                                        class="form-control"
                                        v-model="editBasicFormData[field.column_id]"
                                        :placeholder="field.label"
                                        :required="field.required"
                                        autocomplete="off"
                                    />
                                </div>
                            </div>
                            
                            <div class="edit-form-actions">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="suggestEditLoading">
                                    <span v-show="suggestEditLoading" class="spinner-border spinner-border-sm"></span>
                                    <span v-show="!suggestEditLoading">Suggest Edit</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Pending List Modal -->
    <div class="modal fade action-sheet" id="pendingListModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Pending List</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <ul class="listview image-listview inset">
                            <li v-for="(member, index) in this.pending_contacts" v-bind:key="member.id">
                                <a href="javascript:void(0)" class="item">
                                    <span class="sl-no">{{ (index + 1) }}</span>
                                    &nbsp;&nbsp;
                                    <div class="in">
                                        <div>
                                            <header class="text-info" v-if="member.registered == 'Y' || member.registered == 1 || member.registered == '1'">Registered</header>
                                            <b class="list-item-text">{{ member.name }}({{ member.contact_id }})</b>
                                            <footer>
                                                <span class="text-primary">
                                                    {{ member.mobile ? member.mobile : 'No Number' }}
                                                </span>
                                            </footer>
                                        </div>
                    <div class="card-button">
                                            <button type="button" data-bs-dismiss="modal" class="btn btn-link btn-icon"
                                                @click="gotoEdit(member.mobile)">
                                                <ion-icon name="eye-outline"></ion-icon>
                                            </button>
                                        </div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                        <div class="form-group basic">
                            <button type="button" data-bs-dismiss="modal"
                                class="btn btn-secondary btn-cancel btn-lg col-12">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <alert-model :type="alert_type" :message="alert_message" :redirectRoute="alertRedirectRoute" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>

<script>
import {
    Form
} from "vee-validate";
import { defineRule } from 'vee-validate';
import UserService from "../../services/user.service";
import $ from "jquery";
import AlertModel from "./../layouts/AlertModel.vue";
import DialogModel from "./../layouts/DialogModel.vue";

// Define validation rules
defineRule('required', value => {
    // Treat 0 and '0' as valid values (for Yes/No fields)
    if (value === 0 || value === '0') {
        return true;
    }
    // Check for null, undefined, empty string, or empty array
    if (value === null || value === undefined || value === '') {
        return 'This field is required';
    }
    if (typeof value === 'string' && !value.trim()) {
        return 'This field is required';
    }
    if (Array.isArray(value) && !value.length) {
        return 'This field is required';
    }
    return true;
});

export default {
    name: "CallFollowUpV2Edit",
    props: {
        unit_id: null,
        permissions: Object,
    },
    components: {
           Form,
           AlertModel,
           DialogModel,
    },
    data() {
        return {
            btn_loading: false,
            search_loading: false,
            loading: false,
            loading_list: false,
            form_data_loading: false,
            search_qry: '',
            alert_type: "",
            alert_message: "",
            dialog_message: "",
            dialog_action: "",
            dialog_action_params: null,
            fields: [],
            basicFields: [], // Store basic fields separately
            formData: {
                name: '',
                mobile: '',
                mobile2: '',
                whatsapp: '',
                comments: '',
                status: '',
                calling_status: '',
                calling_status_temp: '', // For temporary storage
                reference_id: '',
            },
            questians_responses: [],
            responseData: {
                campign: [],
                questians: [],
                all_contacts: [],
                permissions: []
            },
            searchResponse: {
                contact: ''
            },
            pending_contacts: [],
            district_list: [],
            zone_list: [],
            unit_list: [],
            status_list: [],
            country_code_list: [],
            tempMemberData: null,
            showContactAlternativesList: false,
            validContactsList: [],
            alertRedirectRoute: '',
            activeDetailTab: 'survey',
            educationCache: {}, // Cache for education names
            educationLoading: false, // Flag to prevent multiple API calls
            editBasicFormData: {}, // Form data for editing basic details
            suggestEditLoading: false, // Loading state for suggest edit
            directoryContact: null, // Data from directory_contacts table
            valueDifferences: {}, // Value differences between campaign and directory contacts
            confirmedValues: {}, // Mentor's confirmed values (field -> 'campaign' or 'directory')
            callAndConfirmCollapsed: true, // Collapse "Call and Confirm" section by default to save space
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        isFromReport() {
            // Check if we're viewing contacts from the report page
            // When coming from report, route has mobile param but we're not on edit page
            return this.$route.params.mobile && 
                   !this.$route.path.includes('call-follow-up-edit-v2') &&
                   !this.searchResponse.contact;
        },
        enabledFields() {
            // Only include regular fields (not basic fields) for the Survey form
            // Basic fields (starting with 'b_') are shown in the Basic Details Card only
            // Exclude reference_id (header) and additional_info (Basic Details card) from survey
            const excludeFromSurvey = ['reference_id', 'additional_info'];
            return (this.fields || [])
                .filter(field => field.enabled && !excludeFromSurvey.includes(field.column_id))
                .sort((a, b) => (a.order || 0) - (b.order || 0));
        },
        // Call and Confirm: show only enabled fields, and only when Value 1 and Value 2 differ (including N/A)
        filteredValueDifferences() {
            const diffs = this.valueDifferences || {};
            const out = {};
            for (const field of Object.keys(diffs)) {
                if (!this.isBasicFieldEnabled(field)) continue;
                const diff = diffs[field];
                const dirVal = this.getDisplayValueForDiff(field, diff.directory_value ?? this.getDirectoryValueForDiffField(field)) || 'N/A';
                const campVal = this.getDisplayValueForDiff(field, diff.campaign_value) || 'N/A';
                if (String(dirVal).trim() !== String(campVal).trim()) {
                    out[field] = diff;
                }
            }
            return out;
        },
        // Get editable basic fields (only enabled fields)
        editableBasicFields() {
            if (!this.basicFields || this.basicFields.length === 0) {
                return [];
            }
            return this.basicFields.filter(field => field.enabled);
        },
        // Basic detail fields for the edit form - only enabled fields (same as Basic Details card and Call and Confirm)
        filteredEditableBasicFields() {
            const allEditFields = [
                { column_id: 'b_name', label: 'Name', type: 'text' },
                { column_id: 'b_gender', label: 'Gender', type: 'Select', options: [{ value: 'Male', label: 'Male' }, { value: 'Female', label: 'Female' }] },
                { column_id: 'b_age', label: 'Age', type: 'Number' },
                { column_id: 'b_mobile', label: 'Mobile', type: 'text' },
                { column_id: 'b_whatsapp', label: 'Whatsapp', type: 'text' },
                { column_id: 'b_place', label: 'Current Place', type: 'text' },
                { column_id: 'b_district', label: 'District', type: 'Select' },
                { column_id: 'b_zone', label: 'Zone', type: 'Select' },
                { column_id: 'b_unit', label: 'Unit', type: 'Select' },
                { column_id: 'b_membership_status', label: 'Membership status', type: 'text' },
                { column_id: 'b_job', label: 'Job', type: 'text' },
                { column_id: 'b_education', label: 'Education', type: 'text' },
                { column_id: 'b_institution', label: 'Institution', type: 'text' },
                { column_id: 'b_background', label: 'Background', type: 'textarea' },
                { column_id: 'b_native_place', label: 'Native Place', type: 'text' },
                { column_id: 'b_job_designation', label: 'Job Designation', type: 'text' },
                { column_id: 'b_diabetic', label: 'Diabetic', type: 'Radio', options: [{ value: 'Yes', label: 'Yes' }, { value: 'No', label: 'No' }] },
                { column_id: 'b_disability', label: 'Disability', type: 'text' },
                { column_id: 'b_pr_listener', label: 'PR Listener', type: 'Radio', options: [{ value: 'Yes', label: 'Yes' }, { value: 'No', label: 'No' }] },
                { column_id: 'b_category', label: 'Category', type: 'text' },
                { column_id: 'reference_id', label: 'Reference ID', type: 'text' },
                { column_id: 'additional_info', label: 'Additional Info', type: 'textarea' },
            ];
            
            // Override with campaign config if available (to get correct type, label, options)
            const genderOptions = [{ value: 'Male', label: 'Male' }, { value: 'Female', label: 'Female' }];
            const merged = allEditFields.map(defaultField => {
                let configField = this.basicFields?.find(f => f.column_id === defaultField.column_id);
                if (!configField && defaultField.column_id === 'b_place') {
                    configField = this.basicFields?.find(f => f.column_id === 'b_current_place');
                }
                let field = configField ? { ...defaultField, ...configField, enabled: !!configField?.enabled } : { ...defaultField, enabled: false };
                // Keep b_place as column_id so form binds to correct field (config may use b_current_place)
                if (field.column_id === 'b_current_place') {
                    field = { ...field, column_id: 'b_place' };
                }
                // Gender: always dropdown Male/Female in edit form
                if (field.column_id === 'b_gender') {
                    field = { ...field, type: 'Select', options: field.options?.length ? field.options : genderOptions };
                }
                return field;
            });
            // Show only enabled fields in edit form (when config loaded; when not loaded, show all)
            // Exclude Org Positions, Org Departments, Reference ID, Additional Info — show in Basic Details card only, not in edit form
            const excludeFromEditForm = ['b_org_positions', 'b_org_departments', 'reference_id', 'additional_info'];
            let result = merged.filter(f => !excludeFromEditForm.includes(f.column_id));
            if (this.basicFields && this.basicFields.length > 0) {
                result = result.filter(f => this.isBasicFieldEnabled(f.column_id));
            }
            return result;
        },
        schema() {
            const validationRules = {};
            this.fields.forEach(field => {
                if (field.enabled && field.required) {
                    validationRules[field.column_id] = 'required';
                }
            });
            return validationRules;
        },
        // Effective membership: use ONLY directory contact is_member (API-verified)
        effectiveIsMember() {
            const directory = this.directoryContact;
            if (directory !== null && directory !== undefined) {
                return directory.is_member === 1 || directory.is_member === '1';
            }
            return false;
        },
        // Single source for membership label (card + edit form); badge color matches this
        displayMembershipLabel() {
            const directory = this.directoryContact;
            if (directory && (directory.member_status === 'Member' || directory.member_status === 'Not Member')) {
                return directory.member_status;
            }
            return this.effectiveIsMember ? 'Member' : 'Not Member';
        },
        isMember() {
            return this.effectiveIsMember;
        }
    },

    watch: {
        status_list: {
            handler(newVal, oldVal) {
                if (Array.isArray(newVal) && newVal.length > 0 && (!oldVal || oldVal.length === 0)) {
                    console.log('Status list loaded, checking for stored calling_status');

                    let storedStatus = this.formData.calling_status_temp ||
                                     this.searchResponse?.contact?.calling_status ||
                                     this.formData.calling_status;

                    if (storedStatus && storedStatus !== '') {
                        console.log('Found stored calling_status:', storedStatus);
                        const mapped = this.mapCallingStatus(storedStatus);
                        console.log('Mapped to:', mapped);

                        if (mapped && mapped !== '') {
                            this.formData.calling_status = mapped;
                            this.$nextTick(() => {
                                this.$forceUpdate();
                            });
                        }
                    }
                }
            },
            immediate: true,
            deep: true
        },
        'formData.district_id'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.fetchZones(newVal);
            }
        },
        'formData.b_district'(newVal, oldVal) {
            if (newVal !== oldVal && newVal) {
                this.fetchZones(newVal);
            }
        },
        'formData.zone_id'(newVal, oldVal) {
            if (newVal !== oldVal && newVal) {
                this.fetchUnits(newVal);
            }
        },
        'formData.b_zone'(newVal, oldVal) {
            if (newVal !== oldVal && newVal) {
                this.fetchUnits(newVal);
            }
        },
        confirmedValues: {
            handler(newVal, oldVal) {
                // Watch for changes in confirmedValues and trigger onDiffValueSelected
                if (!oldVal) return;
                for (const fieldName in newVal) {
                    if (newVal[fieldName] !== oldVal[fieldName] && newVal[fieldName]) {
                        console.log('confirmedValues changed for', fieldName, 'to', newVal[fieldName]);
                        this.onDiffValueSelected(fieldName, newVal[fieldName]);
                    }
                }
            },
            deep: true,
            immediate: false
        },
        'editBasicFormData.b_district'(newVal, oldVal) {
            if (newVal !== oldVal && newVal) {
                // Extract district ID from value (could be "imported:Name" or numeric ID)
                let districtId = newVal;
                if (String(newVal).startsWith('imported:')) {
                    // Can't fetch zones for imported names, clear zones
                    this.zone_list = [];
                    this.unit_list = [];
                    if (this.editBasicFormData.b_zone) {
                        this.editBasicFormData.b_zone = '';
                    }
                    if (this.editBasicFormData.b_unit) {
                        this.editBasicFormData.b_unit = '';
                    }
                    return;
                }
                // Use numeric district ID to fetch zones
                this.fetchZones(districtId);
                // Clear zone and unit selections when district changes
                if (this.editBasicFormData.b_zone) {
                    this.editBasicFormData.b_zone = '';
                }
                if (this.editBasicFormData.b_unit) {
                    this.editBasicFormData.b_unit = '';
                }
            }
        },
        'editBasicFormData.b_zone'(newVal, oldVal) {
            if (newVal !== oldVal && newVal) {
                // Extract zone ID from value (could be "imported:Name" or numeric ID)
                let zoneId = newVal;
                if (String(newVal).startsWith('imported:')) {
                    // Can't fetch units for imported names, clear units
                    this.unit_list = [];
                    if (this.editBasicFormData.b_unit) {
                        this.editBasicFormData.b_unit = '';
                    }
                    return;
                }
                // Use numeric zone ID to fetch units
                this.fetchUnits(zoneId);
                // Clear unit selection when zone changes
                if (this.editBasicFormData.b_unit) {
                    this.editBasicFormData.b_unit = '';
                }
            }
        }
    },

    mounted() {
        if (!this.currentUser) {
            location.replace("/");
        } else {
            this.$root.updateParent("Loading...");
            // Debug watcher for test_field value changes
            this.$watch(
                () => this.formData.test_field,
                (newVal, oldVal) => {
                    console.log('test_field value changed:', oldVal, '=>', newVal);
                }
            );
            this.loading_list = true;

            Promise.all([
                this.getComboboxValues('CALL_CAMPAIGN_STATUS'),
                this.getComboboxValues('COUNTRY_CODE'),
                this.getCampign()
            ]).then(() => {
                const storedMemberData = localStorage.getItem('editMemberData');
                if (storedMemberData) {
                    this.loadStoredMemberData(JSON.parse(storedMemberData));
                    localStorage.removeItem('editMemberData');
                }
            }).catch(() => {
                this.loading_list = false;
            });
        }

        window.onpopstate = function () {
            if ($("body").hasClass("modal-open")) {
                location.reload();
            }
        };
    },

    methods: {
        hasActivityTracking() {
            // Show activity section only when at least one label is configured
            return !!(
                this.responseData &&
                this.responseData.campign &&
                (
                    (this.responseData.campign.activity_1_label && this.responseData.campign.activity_1_label.trim() !== '') ||
                    (this.responseData.campign.activity_2_label && this.responseData.campign.activity_2_label.trim() !== '')
                )
            );
        },

        getActivityLabel(index) {
            if (!this.responseData || !this.responseData.campign) {
                return '';
            }
            if (index === 1) {
                return this.responseData.campign.activity_1_label || '';
            }
            if (index === 2) {
                return this.responseData.campign.activity_2_label || '';
            }
            return '';
        },

        toggleActivity(member, activityIndex) {
            if (!member || !this.responseData || !this.responseData.campign) {
                return;
            }

            const payload = {
                campaign_id: this.responseData.campign.id,
                contact_id: member.id,
                activity_date: new Date().toISOString().slice(0, 10),
            };

            if (activityIndex === 1) {
                payload.activity_1 = member._activity_1 ? 1 : 0;
            } else if (activityIndex === 2) {
                payload.activity_2 = member._activity_2 ? 1 : 0;
            }

            UserService.authPostRequest('v2/store-campign-activity', payload)
                .then((response) => {
                    if (response.data.status !== 'success') {
                        // Revert checkbox on failure
                        if (activityIndex === 1) {
                            member._activity_1 = !member._activity_1;
                        } else if (activityIndex === 2) {
                            member._activity_2 = !member._activity_2;
                        }
                    }
                })
                .catch(() => {
                    if (activityIndex === 1) {
                        member._activity_1 = !member._activity_1;
                    } else if (activityIndex === 2) {
                        member._activity_2 = !member._activity_2;
                    }
                });
        },

        getCampign() {
            return new Promise((resolve, reject) => {
                let data = {
                    id: this.$route.params.id,
                    mobile: this.$route.params.mobile ? this.$route.params.mobile : null
                }

                const campaignPromise = UserService.authPostRequest('v2/get-call-campign', data);
                const fieldsPromise = UserService.authPostRequest('v2/get-call-campign-fields', {
                    campaign_id: this.$route.params.id
                });

                Promise.all([campaignPromise, fieldsPromise]).then(([campaignResponse, fieldsResponse]) => {
                    if (campaignResponse.data.status === 'success') {
                        this.loading_list = false;

                        // Initialize activities for all contacts (list view) based on today's activity flags
                        const mappedContacts = (campaignResponse.data.data.all_contacts || []).map(contact => {
                            return {
                                ...contact,
                                _activity_1: !!contact.today_activity_1,
                                _activity_2: !!contact.today_activity_2,
                            };
                        });

                        // Preserve original response structure but replace all_contacts with mapped version
                        this.responseData = {
                            ...campaignResponse.data.data,
                            all_contacts: mappedContacts,
                        };

                        this.pending_contacts = campaignResponse.data.data.pending_contacts;
                        this.district_list = campaignResponse.data.data.district;

                        if (fieldsResponse.data.status === 'success') {
                            // Handle basic fields
                            if (fieldsResponse.data.data.basic_fields && fieldsResponse.data.data.basic_fields.length > 0) {
                                console.log('Basic fields from API:', fieldsResponse.data.data.basic_fields);
                                
                                this.basicFields = fieldsResponse.data.data.basic_fields.map(field => {
                                    let fieldType = field.type ? this.mapBackendFieldType(field.type) : this.determineFieldType(field.column_id);
                                    
                                    // Parse options from API - handle both JSON arrays and comma-separated strings
                                    let options = field.options;
                                    if (options) {
                                        if (typeof options === 'string') {
                                            // Try JSON parse first
                                            try {
                                                options = JSON.parse(options);
                                            } catch (e) {
                                                // If not JSON, treat as comma-separated string
                                                if (options.includes(',')) {
                                                    options = options.split(',').map(opt => {
                                                        const trimmed = opt.trim();
                                                        return {
                                                            value: trimmed,
                                                            label: trimmed
                                                        };
                                                    });
                                                } else if (options.trim()) {
                                                    options = [{
                                                        value: options.trim(),
                                                        label: options.trim()
                                                    }];
                                                } else {
                                                    options = [];
                                                }
                                            }
                                        }
                                        
                                        // Ensure options are in correct format
                                        if (Array.isArray(options)) {
                                            options = options.map(opt => {
                                                if (typeof opt === 'object' && opt !== null) {
                                                    return {
                                                        value: String(opt.value !== undefined ? opt.value : opt),
                                                        label: opt.label || opt.name || opt.text || String(opt.value !== undefined ? opt.value : opt)
                                                    };
                                                }
                                                return {
                                                    value: String(opt),
                                                    label: String(opt)
                                                };
                                            });
                                        }
                                    } else {
                                        options = [];
                                    }
                                    
                                    return {
                                        ...field,
                                        type: fieldType,
                                        options: options
                                    };
                                });
                                
                                // Initialize formData for basic fields
                                this.basicFields.forEach(field => {
                                    if (field.type === 'Checkbox') {
                                        this.formData[field.column_id] = [];
                                    } else {
                                        this.formData[field.column_id] = '';
                                    }
                                    
                                    // Handle special cases for basic fields
                                    if (field.column_id === 'b_wing') {
                                        this.formData[field.column_id + '_text'] = '';
                                    }
                                    if (field.type === 'Number' && field.column_id === 'b_mobile') {
                                        this.formData[field.column_id + '_country_code'] = '+91';
                                    }
                                });
                            }
                            
                            // Handle regular fields
                            if (fieldsResponse.data.data.fields && fieldsResponse.data.data.fields.length > 0) {
                                console.log('Fields from API:', fieldsResponse.data.data.fields);

                                this.fields = fieldsResponse.data.data.fields.map(field => {
                                    // Use backend field type first, then fallback to determination
                                    let fieldType = field.type ? this.mapBackendFieldType(field.type) : this.determineFieldType(field.column_id);

                                    // Parse options if string
                                    // Parse options from API - handle both JSON arrays and comma-separated strings
                                    let options = field.options;
                                    if (options) {
                                        if (typeof options === 'string') {
                                            // Try JSON parse first
                                            try {
                                                options = JSON.parse(options);
                                            } catch (e) {
                                                // If not JSON, treat as comma-separated string
                                                if (options.includes(',')) {
                                                    options = options.split(',').map(opt => {
                                                        const trimmed = opt.trim();
                                                        return {
                                                            value: trimmed,
                                                            label: trimmed
                                                        };
                                                    });
                                                } else if (options.trim()) {
                                                    options = [{
                                                        value: options.trim(),
                                                        label: options.trim()
                                                    }];
                                                } else {
                                                    options = [];
                                                }
                                            }
                                        }
                                        
                                        // Ensure options are in correct format
                                        if (Array.isArray(options)) {
                                            options = options.map(opt => {
                                                if (typeof opt === 'object' && opt !== null) {
                                                    return {
                                                        value: String(opt.value !== undefined ? opt.value : opt),
                                                        label: opt.label || opt.name || opt.text || String(opt.value !== undefined ? opt.value : opt)
                                                    };
                                                }
                                                return {
                                                    value: String(opt),
                                                    label: String(opt)
                                                };
                                            });
                                        }
                                    } else {
                                        options = [];
                                    }

                                    return {
                                        ...field,
                                        type: fieldType,
                                        options: options
                                    };
                                });

                                // Initialize formData for regular fields
                                this.fields.forEach(field => {
                                    // Initialize checkbox fields as arrays
                                    if (field.type === 'Checkbox') {
                                        this.formData[field.column_id] = [];
                                    } else {
                                        this.formData[field.column_id] = '';
                                    }

                                    if (field.column_id === 'wing') {
                                        this.formData[field.column_id + '_text'] = '';
                                    }
                                    if (field.type === 'Number' &&
                                        ['mobile2', 'whatsapp', 'mobile_new'].includes(field.column_id)) {
                                        this.formData[field.column_id + '_country_code'] = '+91';
                                    }
                                });
                            }
                            
                            // Also handle all_fields if provided (for backward compatibility)
                            if (fieldsResponse.data.data.all_fields && fieldsResponse.data.data.all_fields.length > 0) {
                                const allFields = fieldsResponse.data.data.all_fields.map(field => {
                                    let fieldType = field.type ? this.mapBackendFieldType(field.type) : this.determineFieldType(field.column_id);
                                    
                                    let options = field.options;
                                    if (options && typeof options === 'string') {
                                        try {
                                            options = JSON.parse(options);
                                        } catch (e) {
                                            console.log('Could not parse options for', field.column_id);
                                        }
                                    }
                                    
                                    return {
                                        ...field,
                                        type: fieldType,
                                        options: options
                                    };
                                });
                                
                                // Separate into basic and regular if not already separated
                                if (this.basicFields.length === 0 && this.fields.length === 0) {
                                    this.basicFields = allFields.filter(f => f.column_id && f.column_id.startsWith('b_'));
                                    this.fields = allFields.filter(f => !f.column_id || !f.column_id.startsWith('b_'));
                                }
                            }
                        }

                        if (this.tempMemberData) {
                            this.populateFormDirectly(this.tempMemberData);
                            this.tempMemberData = null;
                        }

                        this.$root.updateParent('Call Campaign');
                        resolve();
                    } else {
                        this.loading_list = false;
                        this.alert_type = 'Error';
                        this.alert_message = campaignResponse.data.message || 'Failed to load campaign data';
                        this.$refs.alert_model.openModel();
                        reject();
                    }
                }).catch((error) => {
                    this.loading_list = false;
                    this.alert_type = 'Error';
                    this.alert_message = error.response?.data?.message || 'Network error occurred';
                    this.$refs.alert_model.openModel();
                    reject();
                });
            });
        },

        getFieldOptions(field) {
            // Use only API-provided options - no hardcoded fallbacks
            if (field.options && field.options.length > 0) {
                console.log(`Using API options for ${field.column_id}:`, field.options);

                if (Array.isArray(field.options)) {
                    return field.options.map(opt => {
                        if (typeof opt === 'object' && opt !== null) {
                            return {
                                value: String(opt.value !== undefined ? opt.value : opt),
                                label: opt.label || opt.name || opt.text || String(opt.value || opt)
                            };
                        }
                        return {
                            value: String(opt),
                            label: String(opt)
                        };
                    });
                }
            }

            // For dynamic fields (district/zone/unit), use API-loaded lists if options not provided
            // These should ideally come from API options, but keeping as fallback for cascading dropdowns
            if (field.column_id === 'district_id' || field.column_id === 'b_district') {
                const options = [];
                // Always add stored name from import as first option if it exists (so it shows in dropdown)
                const storedName = this.getStoredDistrictZoneUnitName('district');
                console.log('getFieldOptions for b_district: storedName=', storedName, 'district_list length=', this.district_list?.length);
                if (storedName) {
                    options.push({
                        value: 'imported:' + storedName,
                        label: storedName
                    });
                }
                // Add org districts
                if (Array.isArray(this.district_list) && this.district_list.length > 0) {
                    const orgOptions = this.district_list.map(district => ({
                        value: String(district.id),
                        label: district.name
                    }));
                    options.push(...orgOptions);
                }
                console.log('getFieldOptions for b_district: returning', options.length, 'options');
                return options;
            }
            
            if (field.column_id === 'zone_id' || field.column_id === 'b_zone') {
                const options = [];
                // Always add stored name from import as first option if it exists (so it shows in dropdown)
                const storedName = this.getStoredDistrictZoneUnitName('zone');
                if (storedName) {
                    options.push({
                        value: 'imported:' + storedName,
                        label: storedName
                    });
                }
                // Add org zones
                if (Array.isArray(this.zone_list) && this.zone_list.length > 0) {
                    const orgOptions = this.zone_list.map(zone => ({
                        value: String(zone.id),
                        label: zone.name
                    }));
                    options.push(...orgOptions);
                }
                return options;
            }
            
            if (field.column_id === 'unit_id' || field.column_id === 'b_unit') {
                const options = [];
                // Always add stored name from import as first option if it exists (so it shows in dropdown)
                const storedName = this.getStoredDistrictZoneUnitName('unit');
                if (storedName) {
                    options.push({
                        value: 'imported:' + storedName,
                        label: storedName
                    });
                }
                // Add org units
                if (Array.isArray(this.unit_list) && this.unit_list.length > 0) {
                    const orgOptions = this.unit_list.map(unit => ({
                        value: String(unit.id),
                        label: unit.name
                    }));
                    options.push(...orgOptions);
                }
                return options;
            }

            // For calling_status, use API-loaded status list if options not provided
            if (field.column_id === 'calling_status') {
                if (Array.isArray(this.status_list) && this.status_list.length > 0) {
                    return this.status_list.map(opt => ({
                        value: String(opt.value || opt.item_value || opt.id),
                        label: opt.label || opt.name || opt.text || 'Option'
                    }));
                }
            }

            // Gender: always Male/Female dropdown in edit form
            if (field.column_id === 'b_gender' || field.column_id === 'gender') {
                return [{ value: 'Male', label: 'Male' }, { value: 'Female', label: 'Female' }];
            }

            // No hardcoded options - return empty array if API doesn't provide options
            console.warn(`No options provided from API for field: ${field.column_id}`);
            return [];
        },

        // Helper methods for Basic Details display
        getGenderLabel(value) {
            if (!value) return '';
            const val = String(value).toLowerCase();
            if (val === 'male' || val === '1') return 'Male';
            if (val === 'female' || val === '2') return 'Female';
            return value;
        },

        getDistrictName(districtId) {
            if (!districtId) return '';
            const district = this.district_list.find(d => d.id == districtId);
            return district ? district.name : '';
        },

        getZoneName(zoneId) {
            if (!zoneId) return '';
            const zone = this.zone_list.find(z => z.id == zoneId);
            return zone ? zone.name : '';
        },

        getUnitName(unitId) {
            if (!unitId) return '';
            const unit = this.unit_list.find(u => u.id == unitId);
            return unit ? unit.name : '';
        },

        getEducationName(educationId) {
            if (!educationId) return '';
            
            // First, check if education name is already provided by backend
            const contact = this.searchResponse.contact;
            if (contact) {
                if (contact.b_education_name) {
                    return contact.b_education_name;
                }
                if (contact.education_name) {
                    return contact.education_name;
                }
            }
            
            // If it's already a name (not a number), return it
            if (isNaN(educationId)) {
                return educationId;
            }
            
            // Try to find in field options if available
            const educationField = this.fields.find(f => f.column_id === 'b_education' || f.column_id === 'education');
            if (educationField) {
                // Try field.options first
                if (educationField.options && educationField.options.length > 0) {
                    const education = educationField.options.find(e => {
                        const value = e.value !== undefined ? e.value : (e.id !== undefined ? e.id : null);
                        return value !== null && String(value) === String(educationId);
                    });
                    if (education) {
                        return education.label || education.name || education.text || '';
                    }
                }
                
                // Try getFieldOptions method
                const options = this.getFieldOptions(educationField);
                if (options && options.length > 0) {
                    const education = options.find(e => String(e.value) === String(educationId));
                    if (education) {
                        return education.label || education.name || '';
                    }
                }
            }
            
            // Check cache
            if (this.educationCache && this.educationCache[educationId]) {
                return this.educationCache[educationId];
            }
            
            // Return empty - will show ID as fallback
            return '';
        },

        getWingLabel(value) {
            if (!value && value !== 0) return '';
            const wingMap = {
                '1': 'ORG',
                '2': 'Youth',
                '3': 'Students',
                '4': 'Womens',
                '6': 'Girls'
            };
            const valueStr = String(value).trim();
            return wingMap[valueStr] || value;
        },
        
        // Helper method for Basic Fields - gets value from formData or contact (basic fields are now columns)
        getBasicFieldValue(columnId) {
            const formValue = this.formData[columnId];
            const contactValue = this.searchResponse.contact?.[columnId];
            
            // Basic fields are now stored in separate columns, not in custom_fields
            return formValue || contactValue;
        },

        // Check if a basic field is enabled in campaign configuration
        isBasicFieldEnabled(columnId) {
            // If basicFields configuration hasn't loaded yet, show all fields by default
            if (!this.basicFields || this.basicFields.length === 0) {
                return true;
            }
            // Campaign config may use b_current_place for "Current Place"; app uses b_place — treat as same
            const altId = columnId === 'b_place' ? 'b_current_place' : (columnId === 'b_current_place' ? 'b_place' : null);
            let field = this.basicFields.find(f => f.column_id === columnId);
            if (!field && altId) {
                field = this.basicFields.find(f => f.column_id === altId);
            }
            return field ? field.enabled : false;
        },

        // Get value from directory_contacts data (0 and "0" are valid values)
        getDirectoryFieldValue(fieldName) {
            if (!this.directoryContact) return null;
            const v = this.directoryContact[fieldName];
            return (v !== undefined && v !== null) ? v : null;
        },
        // True when directory contact has a value for the field (including 0 / "0")
        hasDirectoryValue(fieldName) {
            if (!this.directoryContact) return false;
            const v = this.directoryContact[fieldName];
            return v !== undefined && v !== null;
        },

        // Get display name for district/zone/unit from directory_contacts
        getDirectoryFieldDisplayName(type) {
            if (!this.directoryContact) return null;
            if (type === 'district') return this.directoryContact.district_name || (this.directoryContact.district ? this.directoryContact.district.name : null);
            if (type === 'zone') return this.directoryContact.zone_name || (this.directoryContact.zone ? this.directoryContact.zone.name : null);
            if (type === 'unit') return this.directoryContact.unit_name || (this.directoryContact.unit ? this.directoryContact.unit.name : null);
            return null;
        },

        // Prefer campaign contact (already stored) over directory for display - so saved changes are visible
        getBasicDisplayValue(bField, dirField) {
            const campaign = this.getBasicFieldValue(bField) || this.formData[dirField] || this.searchResponse.contact?.[dirField] || this.searchResponse.contact?.[bField];
            if (campaign !== undefined && campaign !== null && campaign !== '') return campaign;
            return this.getDirectoryFieldValue(dirField);
        },
        // Stored name from import (Excel) when no org ID match — show in card and "From import:" in edit form
        getStoredDistrictZoneUnitName(type) {
            const contact = this.searchResponse?.contact;
            if (!contact) return null;
            if (type === 'district') return contact.b_district_name || null;
            if (type === 'zone') return contact.b_zone_name || null;
            if (type === 'unit') return contact.b_unit_name || null;
            return null;
        },
        getBasicDisplayNameDistrictZoneUnit(type) {
            const storedName = this.getStoredDistrictZoneUnitName(type);
            if (storedName) return storedName;
            const idField = type === 'district' ? 'b_district' : type === 'zone' ? 'b_zone' : 'b_unit';
            const idVal = this.getBasicFieldValue(idField) || this.formData[type + '_id'] || this.searchResponse.contact?.[type + '_id'] || this.searchResponse.contact?.[idField];
            const name = type === 'district' ? this.getDistrictName(idVal) : type === 'zone' ? this.getZoneName(idVal) : this.getUnitName(idVal);
            if (name) return name;
            return this.getDirectoryFieldDisplayName(type);
        },

        // Check if a field has a value difference between campaign and directory contacts
        hasValueDifference(fieldName) {
            return this.valueDifferences && this.valueDifferences[fieldName] !== undefined;
        },

        // Only true when BOTH values exist AND differ (for Edit form: show "Values differ - select correct one" only then)
        hasActualValueDifference(fieldName) {
            const diff = this.valueDifferences && this.valueDifferences[fieldName];
            if (!diff) return false;
            const dirVal = this.getDisplayValueForDiff(fieldName, diff.directory_value ?? this.getDirectoryValueForDiffField(fieldName)) || 'N/A';
            const campVal = this.getDisplayValueForDiff(fieldName, diff.campaign_value) || 'N/A';
            const dirOk = dirVal !== 'N/A' && String(dirVal).trim() !== '';
            const campOk = campVal !== 'N/A' && String(campVal).trim() !== '';
            return dirOk && campOk && String(dirVal).trim() !== String(campVal).trim();
        },

        // Get a display-friendly value for difference display
        getDisplayValueForDiff(field, value) {
            if (value === null || value === undefined || value === '') return 'N/A';
            // For district/zone/unit fields, try to get names
            if (field === 'b_district' && value && !isNaN(value)) {
                return this.getDistrictName(value) || value;
            }
            if (field === 'b_zone' && value && !isNaN(value)) {
                return this.getZoneName(value) || value;
            }
            if (field === 'b_unit' && value && !isNaN(value)) {
                return this.getUnitName(value) || value;
            }
            if (field === 'b_gender') {
                return this.getGenderLabel(value) || value;
            }
            // Yes/No fields (stored as 0/1 or "Yes"/"No")
            if (field === 'b_pr_listener' || field === 'b_diabetic' || field === 'b_disability') {
                const v = String(value).toLowerCase();
                if (v === '1' || v === 'yes' || v === 'true') return 'Yes';
                if (v === '0' || v === 'no' || v === 'false') return 'No';
                return value;
            }
            return value;
        },

        // Call and Confirm only: display value or empty string (never show N/A)
        getDiffValueDisplay(field, value) {
            const v = this.getDisplayValueForDiff(field, value);
            return (v === 'N/A' || v === null || v === undefined || v === '') ? '' : String(v).trim();
        },

        // Label for value-diff row: "Job 1:", "Job 2:" etc. (instead of "Contact List:" / "Campaign:")
        getDiffSourceLabel(fieldName, oneOrTwo) {
            const base = this.getFieldLabel(fieldName);
            return base ? base + ' ' + oneOrTwo + ':' : (oneOrTwo === 1 ? 'Contact List:' : 'Campaign:');
        },

        // Directory field name for campaign b_ field (for fallback when directory_value is missing in API)
        getDirectoryFieldForDiffField(fieldName) {
            const map = { b_name: 'name', b_age: 'age', b_gender: 'gender', b_mobile: 'mobile', b_whatsapp: 'whatsapp', b_place: 'place', b_district: 'district_id', b_zone: 'zone_id', b_unit: 'unit_id', b_wing: 'wing', b_job: 'job', b_education: 'education', b_institution: 'institution', b_background: 'background', b_native_place: 'native_place', b_job_designation: 'job_designation', b_diabetic: 'diabetic', b_disability: 'disability', b_pr_listener: 'pr_listener', b_category: 'category', remarks: 'remarks', comments: 'comments' };
            return map[fieldName] || null;
        },

        // First-stored value from directory_contact when API did not send directory_value (so "Call and Confirm" shows both values)
        getDirectoryValueForDiffField(fieldName) {
            if (!this.directoryContact) return null;
            const dirField = this.getDirectoryFieldForDiffField(fieldName);
            if (!dirField) return null;
            const v = this.directoryContact[dirField];
            return v !== undefined && v !== null && v !== '' ? v : null;
        },

        // Get human-readable label for a b_ field
        getFieldLabel(fieldName) {
            const labels = {
                'b_name': 'Name',
                'b_age': 'Age',
                'b_gender': 'Gender',
                'b_mobile': 'Mobile',
                'b_whatsapp': 'WhatsApp',
                'b_place': 'Current Place',
                'b_district': 'District',
                'b_zone': 'Zone',
                'b_unit': 'Unit',
                'b_wing': 'Wing',
                'b_job': 'Job',
                'b_education': 'Education',
                'b_institution': 'Institution',
                'b_background': 'Background',
                'b_membership_status': 'Membership Status',
                'b_native_place': 'Native Place',
                'b_job_designation': 'Job Designation',
                'b_diabetic': 'Diabetic',
                'b_disability': 'Disability',
                'b_pr_listener': 'PR Listener',
                'b_category': 'Category',
                'remarks': 'Remarks',
                'comments': 'Comments',
            };
            // Also check basicFields for label
            const basicField = this.basicFields?.find(f => f.column_id === fieldName);
            return basicField?.label || labels[fieldName] || fieldName;
        },

        // Check if a field should be readonly in the edit form
        isFieldReadonly(columnId) {
            // Mobile and membership status are always readonly
            if (columnId === 'b_mobile' || columnId === 'b_membership_status') {
                return true;
            }
            // District, zone, unit are readonly for members
            if (this.isMember && (columnId === 'b_district' || columnId === 'b_zone' || columnId === 'b_unit')) {
                return true;
            }
            return false;
        },

        // Get display value for readonly fields (resolve IDs to names)
        getReadonlyDisplayValue(columnId) {
            const rawValue = this.editBasicFormData[columnId];
            if (columnId === 'b_district') {
                return this.getStoredDistrictZoneUnitName('district') || this.getDirectoryFieldDisplayName('district') || this.getDistrictName(rawValue) || rawValue;
            }
            if (columnId === 'b_zone') {
                return this.getStoredDistrictZoneUnitName('zone') || this.getDirectoryFieldDisplayName('zone') || this.getZoneName(rawValue) || rawValue;
            }
            if (columnId === 'b_unit') {
                return this.getStoredDistrictZoneUnitName('unit') || this.getDirectoryFieldDisplayName('unit') || this.getUnitName(rawValue) || rawValue;
            }
            if (columnId === 'b_membership_status') {
                return this.getMembershipStatusLabel(rawValue);
            }
            return rawValue;
        },

        // Show "Member" or "Not Member" based on verified membership from API
        // ALWAYS use effectiveIsMember - never trust raw value from directory/campaign data
        getMembershipStatusLabel() {
            return this.effectiveIsMember ? 'Member' : 'Not Member';
        },

        // Handle diff value selection - update the form field with selected value
        onDiffValueSelected(fieldName, source) {
            console.log('onDiffValueSelected called:', fieldName, source);
            let selectedValue = null;
            if (source === 'directory') {
                const diff = this.valueDifferences[fieldName];
                console.log('Directory diff:', diff);
                if (diff) {
                    selectedValue = diff.directory_value || '';
                }
            } else if (source === 'campaign') {
                const diff = this.valueDifferences[fieldName];
                console.log('Campaign diff:', diff);
                if (diff) {
                    selectedValue = diff.campaign_value || '';
                }
            }
            
            console.log('Selected value:', selectedValue, 'Type:', typeof selectedValue);
            
            if (selectedValue === null || selectedValue === '') {
                console.log('Selected value is empty, returning');
                return;
            }
            
            // Special handling for district/zone/unit: convert name to ID if needed, then trigger cascading
            if (fieldName === 'b_district' || fieldName === 'b_zone' || fieldName === 'b_unit') {
                let finalValue = '';
                const strValue = String(selectedValue).trim();
                
                // Check if it's already a numeric ID (handle both string "15" and number 15)
                const numValue = Number(strValue);
                if (!isNaN(numValue) && numValue !== 0 && strValue !== '' && !isNaN(parseFloat(strValue)) && isFinite(numValue)) {
                    finalValue = String(numValue);
                    console.log('Value is numeric ID:', finalValue);
                } else {
                    // It's a name string - try to find matching org ID
                    console.log('Value is name string:', strValue);
                    let foundId = null;
                    let foundName = null;
                    
                    if (fieldName === 'b_district' && Array.isArray(this.district_list)) {
                        console.log('Searching district_list, length:', this.district_list.length);
                        const searchLower = strValue.toLowerCase().trim();
                        const match = this.district_list.find(d => {
                            if (!d.name) return false;
                            const dName = String(d.name).trim().toLowerCase();
                            // Exact match
                            if (dName === searchLower) return true;
                            // Normalize spaces and try again
                            const normalizedSearch = searchLower.replace(/\s+/g, ' ');
                            const normalizedDName = dName.replace(/\s+/g, ' ');
                            if (normalizedDName === normalizedSearch) return true;
                            // Try partial match (contains)
                            if (dName.includes(searchLower) || searchLower.includes(dName)) return true;
                            return false;
                        });
                        if (match) {
                            foundId = String(match.id);
                            foundName = match.name;
                            console.log('Found district match:', foundName, '-> ID:', foundId);
                        } else {
                            console.log('No district match found for:', strValue);
                            console.log('Sample district names:', this.district_list.slice(0, 5).map(d => d.name));
                        }
                    } else if (fieldName === 'b_zone' && Array.isArray(this.zone_list)) {
                        console.log('Searching zone_list, length:', this.zone_list.length);
                        const searchLower = strValue.toLowerCase().trim();
                        const match = this.zone_list.find(z => {
                            if (!z.name) return false;
                            const zName = String(z.name).trim().toLowerCase();
                            if (zName === searchLower) return true;
                            const normalizedSearch = searchLower.replace(/\s+/g, ' ');
                            const normalizedZName = zName.replace(/\s+/g, ' ');
                            if (normalizedZName === normalizedSearch) return true;
                            if (zName.includes(searchLower) || searchLower.includes(zName)) return true;
                            return false;
                        });
                        if (match) {
                            foundId = String(match.id);
                            foundName = match.name;
                            console.log('Found zone match:', foundName, '-> ID:', foundId);
                        } else {
                            console.log('No zone match found for:', strValue);
                        }
                    } else if (fieldName === 'b_unit' && Array.isArray(this.unit_list)) {
                        console.log('Searching unit_list, length:', this.unit_list.length);
                        const searchLower = strValue.toLowerCase().trim();
                        const match = this.unit_list.find(u => {
                            if (!u.name) return false;
                            const uName = String(u.name).trim().toLowerCase();
                            if (uName === searchLower) return true;
                            const normalizedSearch = searchLower.replace(/\s+/g, ' ');
                            const normalizedUName = uName.replace(/\s+/g, ' ');
                            if (normalizedUName === normalizedSearch) return true;
                            if (uName.includes(searchLower) || searchLower.includes(uName)) return true;
                            return false;
                        });
                        if (match) {
                            foundId = String(match.id);
                            foundName = match.name;
                            console.log('Found unit match:', foundName, '-> ID:', foundId);
                        } else {
                            console.log('No unit match found for:', strValue);
                        }
                    }
                    
                    if (foundId) {
                        finalValue = foundId;
                    } else {
                        // No org match found, use imported: prefix with the exact name from diff
                        finalValue = 'imported:' + strValue;
                        console.log('Using imported format:', finalValue);
                        // Ensure the stored name is set so getFieldOptions includes this option
                        if (this.searchResponse.contact) {
                            if (fieldName === 'b_district') {
                                this.searchResponse.contact.b_district_name = strValue;
                            } else if (fieldName === 'b_zone') {
                                this.searchResponse.contact.b_zone_name = strValue;
                            } else if (fieldName === 'b_unit') {
                                this.searchResponse.contact.b_unit_name = strValue;
                            }
                        }
                    }
                }
                
                console.log('Setting editBasicFormData[' + fieldName + '] =', finalValue);
                // Vue 3 has automatic reactivity - direct assignment works
                this.editBasicFormData[fieldName] = finalValue;
                
                console.log('After set, editBasicFormData[' + fieldName + '] =', this.editBasicFormData[fieldName]);
                
                // Trigger cascading dropdowns
                this.$nextTick(() => {
                    if (fieldName === 'b_district' && finalValue && !String(finalValue).startsWith('imported:')) {
                        console.log('Fetching zones for district:', finalValue);
                        this.fetchZones(finalValue);
                    } else if (fieldName === 'b_zone' && finalValue && !String(finalValue).startsWith('imported:')) {
                        console.log('Fetching units for zone:', finalValue);
                        this.fetchUnits(finalValue);
                    }
                });
            } else {
                // For other fields, just set the value directly
                console.log('Setting non-district/zone/unit field:', fieldName, '=', selectedValue);
                this.editBasicFormData[fieldName] = selectedValue;
            }
        },

        setDetailTab(tab) {
            this.activeDetailTab = tab;
        },

        // Open edit basic details modal
        openEditBasicDetailsModal() {
            // Initialize form data with values from directory_contacts (primary) or campaign contact (fallback)
            this.editBasicFormData = {};
            this.confirmedValues = {}; // Reset confirmed values
            
            // Field mapping from b_ fields to directory_contacts fields
            const directoryFieldMapping = {
                'b_name': 'name',
                'b_age': 'age',
                'b_gender': 'gender',
                'b_mobile': 'mobile',
                'b_whatsapp': 'whatsapp',
                'b_place': 'place',
                'b_district': 'district_id',
                'b_zone': 'zone_id',
                'b_unit': 'unit_id',
                'b_wing': 'wing',
                'b_job': 'job',
                'b_education': 'education',
                'b_institution': 'institution',
                'b_background': 'background',
                'b_membership_status': 'member_status',
                'b_native_place': 'native_place',
                'b_job_designation': 'job_designation',
                'b_diabetic': 'diabetic',
                'b_disability': 'disability',
                'b_pr_listener': 'pr_listener',
                'b_category': 'category',
            };
            
            // Use filteredEditableBasicFields which includes ALL basic fields
            const fields = Array.isArray(this.filteredEditableBasicFields) ? this.filteredEditableBasicFields : [];
            
            // Debug: Log contact data to see what's available
            console.log('Opening edit modal - Contact data:', this.searchResponse.contact);
            console.log('Directory contact:', this.directoryContact);
            console.log('Value differences:', this.valueDifferences);
            console.log('Editable basic fields:', fields);
            
            fields.forEach(field => {
                const columnId = field.column_id;
                const directoryField = directoryFieldMapping[columnId];
                
                // Special handling for district/zone/unit: check for stored names first, then IDs
                if (columnId === 'b_district' || columnId === 'b_zone' || columnId === 'b_unit') {
                    const type = columnId === 'b_district' ? 'district' : columnId === 'b_zone' ? 'zone' : 'unit';
                    const storedName = this.getStoredDistrictZoneUnitName(type);
                    
                    console.log(`Initializing ${columnId}: storedName=${storedName}, contact[${columnId}]=${this.searchResponse.contact?.[columnId]}, directory[${directoryField}]=${this.directoryContact?.[directoryField]}`);
                    
                    // Prioritize: org ID from contact > org ID from directory > stored name
                    let currentValue = '';
                    if (this.searchResponse.contact?.[columnId] !== undefined && this.searchResponse.contact?.[columnId] !== null && this.searchResponse.contact?.[columnId] !== '') {
                        currentValue = String(this.searchResponse.contact[columnId]);
                    } else if (this.directoryContact && directoryField && this.directoryContact[directoryField] !== undefined && this.directoryContact[directoryField] !== null && this.directoryContact[directoryField] !== '') {
                        currentValue = String(this.directoryContact[directoryField]);
                    } else if (storedName) {
                        // No org ID found, use stored name
                        currentValue = 'imported:' + storedName;
                    }
                    
                    console.log(`Setting ${columnId} to: ${currentValue}`);
                    this.editBasicFormData[columnId] = currentValue;
                    
                    // If district is set, fetch zones for it (if it's a numeric ID, not imported name)
                    if (columnId === 'b_district' && currentValue && !String(currentValue).startsWith('imported:')) {
                        this.$nextTick(() => {
                            this.fetchZones(currentValue);
                        });
                    }
                    // If zone is set, fetch units for it (if it's a numeric ID, not imported name)
                    if (columnId === 'b_zone' && currentValue && !String(currentValue).startsWith('imported:')) {
                        this.$nextTick(() => {
                            this.fetchUnits(currentValue);
                        });
                    }
                    
                    return; // Skip normal initialization for these fields
                }
                
                // Prioritize directory_contacts data, then campaign contact data, then formData
                let currentValue = '';
                
                if (this.directoryContact && directoryField && this.directoryContact[directoryField] !== undefined && this.directoryContact[directoryField] !== null && this.directoryContact[directoryField] !== '') {
                    currentValue = this.directoryContact[directoryField];
                } else if (this.searchResponse.contact?.[columnId] !== undefined && this.searchResponse.contact?.[columnId] !== null && this.searchResponse.contact?.[columnId] !== '') {
                    currentValue = this.searchResponse.contact[columnId];
                } else if (this.formData[columnId] !== undefined && this.formData[columnId] !== null && this.formData[columnId] !== '') {
                    currentValue = this.formData[columnId];
                }
                
                console.log(`Field ${columnId}: directory=${this.directoryContact?.[directoryField]}, contact=${this.searchResponse.contact?.[columnId]}, formData=${this.formData[columnId]}, final=${currentValue}`);
                
                // Initialize based on field type
                if (field.type === 'Checkbox') {
                    this.editBasicFormData[columnId] = Array.isArray(currentValue) ? [...currentValue] : (currentValue ? [String(currentValue)] : []);
                } else {
                    this.editBasicFormData[columnId] = currentValue !== null && currentValue !== undefined ? String(currentValue) : '';
                }
                
                // Membership status: use directory contact when loaded so edit form shows same as card
                if (columnId === 'b_membership_status') {
                    this.editBasicFormData[columnId] = this.displayMembershipLabel;
                }
            });
            
            console.log('Edit form data initialized:', this.editBasicFormData);
            
            // Open action sheet (bottom sheet) using jQuery Bootstrap
            this.$nextTick(() => {
                const modalElement = document.getElementById('editBasicDetailsModal');
                if (modalElement) {
                    // Use jQuery Bootstrap for action-sheet (slides from bottom)
                    if (window.$ && window.$(modalElement).modal) {
                        window.$(modalElement).modal('show');
                    } else if (typeof window.bootstrap !== 'undefined') {
                        // Fallback to Bootstrap 5
                        const modal = new window.bootstrap.Modal(modalElement);
                        modal.show();
                    }
                }
            });
        },

        // Submit basic details edit suggestion
        async submitBasicDetailsEdit() {
            this.suggestEditLoading = true;
            
            try {
                // Prepare the data to send
                const contactId = this.searchResponse.contact?.id || this.searchResponse.contact?.contact_id;
                const campaignId = this.$route.params.id;
                
                // Excluded fields (readonly and removed from form)
                const excludedFields = ['b_mobile', 'b_membership_status', 'b_wing', 'b_org_positions', 'b_org_departments'];
                
                const editData = {
                    contact_id: contactId,
                    campaign_id: campaignId,
                    suggested_edits: {},
                    confirmed_values: this.confirmedValues // Send which value mentor confirmed for each diff
                };
                
                // Only include fields that have been changed (exclude readonly/removed fields)
                const fields = Array.isArray(this.filteredEditableBasicFields) ? this.filteredEditableBasicFields : [];
                fields.forEach(field => {
                    const columnId = field.column_id;
                    if (excludedFields.includes(columnId)) return; // Skip readonly fields
                    
                    let newValue = this.editBasicFormData[columnId];
                    
                    // Handle "imported:" prefix for district/zone/unit - extract name and set name field, clear ID
                    if ((columnId === 'b_district' || columnId === 'b_zone' || columnId === 'b_unit') && 
                        String(newValue).startsWith('imported:')) {
                        const storedName = String(newValue).replace('imported:', '');
                        // Set the name field (b_district_name, b_zone_name, b_unit_name)
                        const nameField = columnId === 'b_district' ? 'b_district_name' : 
                                         columnId === 'b_zone' ? 'b_zone_name' : 'b_unit_name';
                        editData.suggested_edits[nameField] = storedName;
                        // Clear the ID field (set to empty so no org match)
                        editData.suggested_edits[columnId] = '';
                        return; // Skip normal change detection for this field
                    }
                    
                    // Note: Name fields (b_district_name etc.) are auto-cleared on the server
                    // when an org ID is set, so we don't need to send empty strings here
                    
                    const currentValue = this.formData[columnId] || 
                                       this.searchResponse.contact?.[columnId] || 
                                       '';
                    
                    // Check if value has changed
                    if (String(newValue) !== String(currentValue)) {
                        editData.suggested_edits[columnId] = newValue;
                    }
                });
                
                // Include form values for confirmed_values (diff selections) so backend saves them and review portal can show them
                Object.keys(this.confirmedValues || {}).forEach(columnId => {
                    if (excludedFields.includes(columnId)) return;
                    const value = this.editBasicFormData[columnId];
                    if (value !== undefined && value !== null && String(value).trim() !== '') {
                        editData.suggested_edits[columnId] = value;
                    }
                });
                
                // Debug: Log what's being sent
                console.log('=== SUBMIT EDIT SUGGESTION ===');
                console.log('editData.suggested_edits:', JSON.stringify(editData.suggested_edits));
                console.log('editData.confirmed_values:', JSON.stringify(editData.confirmed_values));
                console.log('editBasicFormData:', JSON.stringify(this.editBasicFormData));
                
                // Check if there are any changes or confirmed values
                if (Object.keys(editData.suggested_edits).length === 0 && Object.keys(editData.confirmed_values).length === 0) {
                    this.alert_type = 'Warning';
                    this.alert_message = 'No changes detected. Please modify at least one field.';
                    this.$refs.alert_model.openModel();
                    this.suggestEditLoading = false;
                    return;
                }
                
                // Submit to backend
                const response = await UserService.authPostRequest('v2/suggest-basic-details-edit', editData);
                
                if (response.data.status === 'success') {
                    this.alert_type = 'Success';
                    this.alert_message = response.data.message || 'Edit suggestion submitted successfully!';
                    this.$refs.alert_model.openModel();
                    
                    // Close action sheet
                    const modalElement = document.getElementById('editBasicDetailsModal');
                    if (modalElement) {
                        if (window.$ && window.$(modalElement).modal) {
                            window.$(modalElement).modal('hide');
                        } else if (typeof window.bootstrap !== 'undefined') {
                            const modal = window.bootstrap.Modal.getInstance(modalElement);
                            if (modal) {
                                modal.hide();
                            }
                        }
                    }
                } else {
                    this.alert_type = 'Error';
                    this.alert_message = response.data.message || 'Failed to submit edit suggestion.';
                    this.$refs.alert_model.openModel();
                }
            } catch (error) {
                console.error('Error submitting edit suggestion:', error);
                this.alert_type = 'Error';
                this.alert_message = error.response?.data?.message || 'An error occurred while submitting the edit suggestion.';
                this.$refs.alert_model.openModel();
            } finally {
                this.suggestEditLoading = false;
            }
        },

        // Computed-like helper for call history list
        callHistoryList() {
            const contact = this.searchResponse && this.searchResponse.contact;
            if (!contact) return [];
            // Support multiple possible backend shapes
            if (Array.isArray(contact.call_history)) return contact.call_history;
            if (Array.isArray(contact.history)) return contact.history;
            return [];
        },

        formatCallHistoryMain(item) {
            // Try to build a main line similar to "Yesterday, 10:30 AM"
            if (!item) return '';

            // If backend already provides a formatted label/text, prefer that
            if (item.title) return item.title;
            if (item.label) return item.label;
            if (item.text) return item.text;

            const parts = [];
            if (item.date_label) parts.push(item.date_label);
            else if (item.date) parts.push(item.date);

            if (item.time) parts.push(item.time);

            return parts.join(', ');
        },

        formatCallHistoryMeta(item) {
            if (!item) return '';

            // Typical meta: "15 min", "No answer", etc.
            if (item.meta) return item.meta;
            if (item.duration && item.outcome) {
                return `${item.duration} · ${item.outcome}`;
            }
            if (item.duration) return item.duration;
            if (item.outcome) return item.outcome;

            return '';
        },

        openSuggestEditDialog() {
            this.dialog_message = 'Suggest edits to contact data (subject to admin approval).';
            this.dialog_action = '';
            this.dialog_action_params = null;
            this.$refs.dialog_model.openModel();
        },

        search(mobile = null) {
            try {
                if (mobile) {
                    this.search_qry = mobile;
                }
                if (!this.search_qry) {
                    this.alert_type = 'Warning';
                    this.alert_message = 'Please enter a mobile number to search';
                    this.$refs.alert_model.openModel();
                    return;
                }

                this.search_loading = true;
                this.hideContactAlternatives();

                let data = {
                    q: this.search_qry,
                    id: this.$route.params.id,
                }

                UserService.authPostRequest('v2/get-call-campign-contact', data).then(
                    (response) => {
                        if (response.data.status == 'success') {
                            this.search_loading = false;
                            this.searchResponse = response.data.data;
                            
                            // Store directory_contact and value_differences from API
                            this.directoryContact = response.data.data.directory_contact || null;
                            this.valueDifferences = response.data.data.value_differences || {};
                            this.confirmedValues = {}; // Reset confirmed values

                            if (this.searchResponse.contact) {
                                console.log('Contact loaded:', this.searchResponse.contact);
                                console.log('Directory contact:', this.directoryContact);
                                console.log('Value differences:', this.valueDifferences);
                                console.log('Education ID:', this.searchResponse.contact.b_education || this.searchResponse.contact.education);
                                console.log('Education Name:', this.searchResponse.contact.b_education_name || this.searchResponse.contact.education_name);
                                console.log('Custom fields in contact:', this.searchResponse.contact.custom_fields);

                                // Set basic fields
                                this.formData.id = this.searchResponse.contact.id || this.searchResponse.contact.contact_id;
                                this.formData.wisdom_member = this.searchResponse.contact.wisdom_member;
                                this.formData.name = this.searchResponse.contact.name;
                                this.formData.mobile = this.searchResponse.contact.mobile;
                                this.formData.comments = this.searchResponse.contact.comments;
                                // Reference ID and Additional Info (shown in header / Basic Details, not in survey)
                                if (this.searchResponse.contact.reference_id !== undefined && this.searchResponse.contact.reference_id !== null && this.searchResponse.contact.reference_id !== '') {
                                    this.formData.reference_id = String(this.searchResponse.contact.reference_id);
                                }
                                if (this.searchResponse.contact.additional_info !== undefined && this.searchResponse.contact.additional_info !== null && this.searchResponse.contact.additional_info !== '') {
                                    this.formData.additional_info = String(this.searchResponse.contact.additional_info);
                                }

                                // Call populate method which handles custom_fields
                                this.populateFormFromContact(this.searchResponse.contact);
                                this.$root.updateParent('Call Campaign');
                            }
                        } else {
                            this.search_loading = false;
                            if (response.data.data && response.data.data.valid_contacts) {
                                this.showContactAlternativesFromResponse(response.data.data.valid_contacts, response.data.message);
                            } else {
                                this.alert_type = 'Error';
                                this.alert_message = response.data.message || 'Contact not found';
                                this.$refs.alert_model.openModel();
                                this.fetchValidContacts();
                            }
                        }
                    },
                    (error) => {
                        this.search_loading = false;
                        this.alert_type = 'Error';
                        this.alert_message = error.response?.data?.message || 'Network error occurred';
                        this.$refs.alert_model.openModel();
                        this.fetchValidContacts();
                    }
                );
            } catch (error) {
                this.search_loading = false;
                this.alert_type = 'Error';
                this.alert_message = 'An unexpected error occurred';
                this.$refs.alert_model.openModel();
            }
        },

        populateFormFromContact(contactData) {
            this.form_data_loading = true;

            console.log('Populating form with contact:', contactData);
            console.log('Custom fields:', contactData.custom_fields);

            // Clear existing data
            this.fields.forEach(field => {
                if (field.type === 'Checkbox') {
                    this.formData[field.column_id] = [];
                } else {
                    // For participation, always start with empty string (don't show default "No")
                    if (field.column_id === 'participation') {
                        this.formData[field.column_id] = '';
                    } else {
                        this.formData[field.column_id] = '';
                    }
                }
            });

            // First, populate basic fields (now stored in separate columns)
            if (this.basicFields && this.basicFields.length > 0) {
                this.basicFields.forEach(field => {
                    const columnId = field.column_id;
                    let value = contactData[columnId];
                    
                    // Basic fields are now stored in separate columns, not in custom_fields
                    
                    if (value !== undefined && value !== null && value !== '') {
                        if (field.type === 'Select') {
                            this.formData[columnId] = String(value);
                        } else if (field.type === 'Radio') {
                            if (value === true || value === 1 || value === '1' || value === 'Y') {
                                this.formData[columnId] = '1';
                            } else if (value === false || value === 0 || value === '0' || value === 'N') {
                                this.formData[columnId] = '0';
                            } else {
                                this.formData[columnId] = String(value);
                            }
                        } else if (field.type === 'Checkbox') {
                            // Handle checkbox values - convert to clean array
                            if (Array.isArray(value)) {
                                const allValues = [];
                                value.forEach(v => {
                                    const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                    if (cleaned.includes(',')) {
                                        cleaned.split(',').forEach(item => {
                                            if (item.trim()) allValues.push(item.trim());
                                        });
                                    } else if (cleaned) {
                                        allValues.push(cleaned);
                                    }
                                });
                                this.formData[columnId] = [...new Set(allValues)];
                            } else if (typeof value === 'string') {
                                try {
                                    let parsed = JSON.parse(value);
                                    while (typeof parsed === 'string' && (parsed.startsWith('[') || parsed.startsWith('"'))) {
                                        try {
                                            parsed = JSON.parse(parsed);
                                        } catch (e) {
                                            break;
                                        }
                                    }
                                    if (Array.isArray(parsed)) {
                                        const allValues = [];
                                        parsed.forEach(v => {
                                            const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                            if (cleaned.includes(',')) {
                                                cleaned.split(',').forEach(item => {
                                                    if (item.trim()) allValues.push(item.trim());
                                                });
                                            } else if (cleaned) {
                                                allValues.push(cleaned);
                                            }
                                        });
                                        this.formData[columnId] = [...new Set(allValues)];
                                    } else {
                                        const cleaned = typeof parsed === 'string' ? parsed.replace(/[\\'"[\]]/g, '').trim() : String(parsed).trim();
                                        this.formData[columnId] = cleaned ? [cleaned] : [];
                                    }
                                } catch (e) {
                                    const cleaned = value.replace(/[\\'"[\]]/g, '').trim();
                                    this.formData[columnId] = cleaned.includes(',') 
                                        ? cleaned.split(',').map(v => v.trim()).filter(v => v)
                                        : [cleaned].filter(v => v);
                                }
                            } else {
                                this.formData[columnId] = [String(value)];
                            }
                        } else {
                            this.formData[columnId] = String(value);
                        }
                    }
                });
            }
            
            // Then, populate standard fields
            this.fields.forEach(field => {
                const columnId = field.column_id;
                
                // Initialize field if it doesn't exist
                if (!Object.prototype.hasOwnProperty.call(this.formData, columnId)) {
                    if (field.type === 'Checkbox') {
                        this.formData[columnId] = [];
                    } else {
                        this.formData[columnId] = '';
                    }
                }
                
                let value = contactData[columnId];

                // Special handling for participation: only set value if it's explicitly stored (not null/undefined)
                // Check if value exists in contactData or custom_fields
                if (columnId === 'participation') {
                    // Check both direct property and custom_fields
                    const directValue = contactData[columnId];
                    const customFields = contactData.custom_fields;
                    let customValue = null;
                    
                    if (customFields) {
                        const parsedCustomFields = typeof customFields === 'string' ? 
                            (() => { try { return JSON.parse(customFields); } catch(e) { return {}; } })() : 
                            customFields;
                        customValue = parsedCustomFields[columnId];
                    }
                    
                    // Only set value if it's explicitly stored (not null/undefined)
                    // For participation, we need to check if it was actually saved, not just if it's 0
                    const hasStoredValue = (directValue !== undefined && directValue !== null) || 
                                          (customValue !== undefined && customValue !== null);
                    
                    if (hasStoredValue) {
                        const finalValue = directValue !== undefined && directValue !== null ? directValue : customValue;
                        if (finalValue === true || finalValue === 1 || finalValue === '1' || finalValue === 'Y') {
                            this.formData[columnId] = '1';
                        } else if (finalValue === false || finalValue === 0 || finalValue === '0' || finalValue === 'N') {
                            this.formData[columnId] = '0';
                        } else {
                            this.formData[columnId] = String(finalValue);
                        }
                    } else {
                        // No stored value, leave it empty
                        this.formData[columnId] = '';
                    }
                    return; // Skip the rest of the loop for participation
                }

                if (value !== undefined && value !== null && value !== '') {
                    if (field.type === 'Select') {
                        this.formData[columnId] = String(value);
                    } else if (field.type === 'Radio') {
                        if (value === true || value === 1 || value === '1' || value === 'Y') {
                            this.formData[columnId] = '1';
                        } else if (value === false || value === 0 || value === '0' || value === 'N') {
                            this.formData[columnId] = '0';
                        } else {
                            this.formData[columnId] = String(value);
                        }
                    } else if (field.type === 'Checkbox') {
                        // Handle checkbox values - convert to clean array
                        if (Array.isArray(value)) {
                            // Already an array, just clean it
                            const allValues = [];
                            value.forEach(v => {
                                const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                if (cleaned.includes(',')) {
                                    cleaned.split(',').forEach(item => {
                                        if (item.trim()) allValues.push(item.trim());
                                    });
                                } else if (cleaned) {
                                    allValues.push(cleaned);
                                }
                            });
                            this.formData[columnId] = [...new Set(allValues)];
                        } else if (typeof value === 'string') {
                            // Try to parse as JSON array
                            try {
                                let parsed = JSON.parse(value);
                                // Keep parsing if still a string
                                while (typeof parsed === 'string' && (parsed.startsWith('[') || parsed.startsWith('"'))) {
                                    try {
                                        parsed = JSON.parse(parsed);
                                    } catch (e) {
                                        break;
                                    }
                                }
                                // Now clean the parsed value
                                if (Array.isArray(parsed)) {
                                    const allValues = [];
                                    parsed.forEach(v => {
                                        const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                        if (cleaned.includes(',')) {
                                            cleaned.split(',').forEach(item => {
                                                if (item.trim()) allValues.push(item.trim());
                                            });
                                        } else if (cleaned) {
                                            allValues.push(cleaned);
                                        }
                                    });
                                    this.formData[columnId] = [...new Set(allValues)];
                                } else {
                                    const cleaned = typeof parsed === 'string' ? parsed.replace(/[\\'"[\]]/g, '').trim() : String(parsed).trim();
                                    this.formData[columnId] = cleaned ? [cleaned] : [];
                                }
                            } catch (e) {
                                // Not JSON, split by comma
                                const cleaned = value.replace(/[\\'"[\]]/g, '').trim();
                                this.formData[columnId] = cleaned.includes(',') 
                                    ? cleaned.split(',').map(v => v.trim()).filter(v => v)
                                    : [cleaned].filter(v => v);
                            }
                        } else {
                            this.formData[columnId] = [String(value)];
                        }
                        console.log(`Loaded ${columnId} from standard field:`, this.formData[columnId]);
                    } else if (field.type === 'Select') {
                        // For Select fields, ensure empty string for null/undefined values
                        if (value === null || value === undefined || value === '') {
                            this.formData[columnId] = '';
                        } else {
                            this.formData[columnId] = String(value);
                        }
                    } else {
                        this.formData[columnId] = String(value);
                    }
                } else {
                    // No value found - ensure Select fields show default "--select--"
                    if (field.type === 'Select') {
                        this.formData[columnId] = '';
                    }
                }
            });

            // CRITICAL: Handle custom_fields - this is where test_field data is stored
            if (contactData.custom_fields) {
                let customFields = contactData.custom_fields;

                // Parse if it's a string
                if (typeof customFields === 'string') {
                    try {
                        customFields = JSON.parse(customFields);
                        console.log('Parsed custom fields:', customFields);
                    } catch (e) {
                        console.error('Failed to parse custom_fields:', e);
                        customFields = {};
                    }
                }

                // Now populate each custom field
                if (customFields && typeof customFields === 'object') {
                    // Loop through all fields to find custom ones
                    this.fields.forEach(field => {
                        // Skip will_come here as it's handled above in standard fields section
                        if (field.column_id === 'will_come') {
                            return;
                        }
                        
                        // Ensure the field exists in formData before setting
                        if (!Object.prototype.hasOwnProperty.call(this.formData, field.column_id)) {
                            // Initialize the field if it doesn't exist
                            if (field.type === 'Checkbox') {
                                this.formData[field.column_id] = [];
                            } else {
                                this.formData[field.column_id] = '';
                            }
                        }
                        
                        // Check if this field has a value in custom_fields
                        if (customFields[field.column_id] !== undefined && customFields[field.column_id] !== null) {
                            console.log(`Setting custom field ${field.column_id}:`, customFields[field.column_id]);
                            let value = customFields[field.column_id];
                            
                            // Handle Select fields - ensure empty strings are handled
                            if (field.type === 'Select') {
                                // Convert to string and handle empty values
                                if (value === '' || value === null || value === undefined) {
                                    this.formData[field.column_id] = '';
                                } else {
                                    this.formData[field.column_id] = String(value);
                                }
                                return; // Skip checkbox handling for Select fields
                            }
                            
                            // Handle checkbox fields - ensure they're arrays
                            if (field.type === 'Checkbox') {
                                // Recursive function to deeply parse nested JSON
                                const deepParse = (val) => {
                                    if (typeof val === 'string') {
                                        // Keep parsing until we can't anymore
                                        let parsed = val;
                                        let maxAttempts = 10; // Prevent infinite loops
                                        while (maxAttempts > 0 && typeof parsed === 'string' && (parsed.startsWith('[') || parsed.startsWith('"') || parsed.includes('\\'))) {
                                            try {
                                                const newParsed = JSON.parse(parsed);
                                                if (newParsed === parsed) break; // Stop if no change
                                                parsed = newParsed;
                                                maxAttempts--;
                                            } catch (e) {
                                                break;
                                            }
                                        }
                                        return parsed;
                                    }
                                    return val;
                                };
                                
                                // Flatten nested arrays recursively
                                const flattenArray = (arr) => {
                                    if (!Array.isArray(arr)) return [arr];
                                    return arr.reduce((acc, item) => {
                                        if (Array.isArray(item)) {
                                            return acc.concat(flattenArray(item));
                                        }
                                        const parsed = deepParse(item);
                                        if (Array.isArray(parsed)) {
                                            return acc.concat(flattenArray(parsed));
                                        }
                                        return acc.concat(parsed);
                                    }, []);
                                };
                                
                                // Clean the values after parsing
                                const cleanValue = (val) => {
                                    if (typeof val === 'string') {
                                        let cleaned = val;
                                        while (/[\\'"[\]]/.test(cleaned)) {
                                            cleaned = cleaned.replace(/[\\'"[\]]/g, '');
                                        }
                                        return cleaned.trim();
                                    }
                                    return val ? String(val).trim() : '';
                                };
                                
                                if (Array.isArray(value)) {
                                    const flattened = flattenArray(value);
                                    // Split comma-separated values and clean
                                    const allValues = [];
                                    flattened.forEach(v => {
                                        const cleaned = cleanValue(v);
                                        if (cleaned.includes(',')) {
                                            cleaned.split(',').forEach(item => {
                                                const trimmed = item.trim();
                                                if (trimmed) allValues.push(trimmed);
                                            });
                                        } else if (cleaned) {
                                            allValues.push(cleaned);
                                        }
                                    });
                                    this.formData[field.column_id] = [...new Set(allValues)].filter(v => v && v !== '');
                                } else if (typeof value === 'string') {
                                    const parsed = deepParse(value);
                                    if (Array.isArray(parsed)) {
                                        const flattened = flattenArray(parsed);
                                        const allValues = [];
                                        flattened.forEach(v => {
                                            const cleaned = cleanValue(v);
                                            if (cleaned.includes(',')) {
                                                cleaned.split(',').forEach(item => {
                                                    const trimmed = item.trim();
                                                    if (trimmed) allValues.push(trimmed);
                                                });
                                            } else if (cleaned) {
                                                allValues.push(cleaned);
                                            }
                                        });
                                        this.formData[field.column_id] = [...new Set(allValues)].filter(v => v && v !== '');
                                    } else {
                                        const cleaned = cleanValue(parsed);
                                        this.formData[field.column_id] = cleaned ? [cleaned] : [];
                                    }
                                } else {
                                    this.formData[field.column_id] = value ? [String(value)] : [];
                                }
                                console.log(`Final checkbox value for ${field.column_id}:`, this.formData[field.column_id]);
                            } else if (field.type === 'Select') {
                                // Handle Select fields - ensure empty strings are handled
                                if (value === '' || value === null || value === undefined) {
                                    this.formData[field.column_id] = '';
                                } else {
                                    this.formData[field.column_id] = String(value);
                                }
                            } else {
                                this.formData[field.column_id] = value;
                            }
                        }
                    });

                    // Specifically handle test_field if it exists
                    if (customFields.test_field !== undefined) {
                        console.log('Setting test_field:', customFields.test_field);
                        this.formData.test_field = customFields.test_field;
                    }
                }
            }

            // Handle other standard fields...
            ['name', 'mobile', 'place', 'comments'].forEach(fieldName => {
                if (contactData[fieldName] !== undefined && contactData[fieldName] !== null) {
                    this.formData[fieldName] = contactData[fieldName];
                }
            });

            // Handle cascading dropdowns...
            if (contactData.district_id) {
                this.formData.district_id = String(contactData.district_id);
                this.fetchZones(contactData.district_id);

                setTimeout(() => {
                    if (contactData.zone_id) {
                        this.formData.zone_id = String(contactData.zone_id);
                        this.fetchUnits(contactData.zone_id);

                        setTimeout(() => {
                            if (contactData.unit_id) {
                                this.formData.unit_id = String(contactData.unit_id);
                            }
                        }, 500);
                    }
                }, 500);
            }

            this.$nextTick(() => {
                // Force update all custom fields one more time
                if (contactData.custom_fields) {
                    let customFields = contactData.custom_fields;
                    if (typeof customFields === 'string') {
                        try {
                            customFields = JSON.parse(customFields);
                        } catch (e) {
                            customFields = {};
                        }
                    }

                    Object.keys(customFields).forEach(key => {
                        // Skip basic fields (b_*) as they are now stored in separate columns
                        if (key.startsWith('b_')) {
                            return;
                        }
                        
                        // Skip will_come as it's handled in the standard fields section above
                        if (key === 'will_come') {
                            return;
                        }
                        
                        const field = this.fields.find(f => f.column_id === key);
                        let value = customFields[key];
                        
                        // Handle checkbox fields specially
                        if (field && field.type === 'Checkbox') {
                            // Use the same deep parsing logic
                            const deepParse = (val) => {
                                if (typeof val === 'string') {
                                    let parsed = val;
                                    let maxAttempts = 10;
                                    while (maxAttempts > 0 && typeof parsed === 'string' && (parsed.startsWith('[') || parsed.startsWith('"') || parsed.includes('\\'))) {
                                        try {
                                            const newParsed = JSON.parse(parsed);
                                            if (newParsed === parsed) break;
                                            parsed = newParsed;
                                            maxAttempts--;
                                        } catch (e) {
                                            break;
                                        }
                                    }
                                    return parsed;
                                }
                                return val;
                            };
                            
                            const flattenArray = (arr) => {
                                if (!Array.isArray(arr)) return [arr];
                                return arr.reduce((acc, item) => {
                                    if (Array.isArray(item)) {
                                        return acc.concat(flattenArray(item));
                                    }
                                    const parsed = deepParse(item);
                                    if (Array.isArray(parsed)) {
                                        return acc.concat(flattenArray(parsed));
                                    }
                                    return acc.concat(parsed);
                                }, []);
                            };
                            
                            const cleanValue = (val) => {
                                if (typeof val === 'string') {
                                    let cleaned = val;
                                    while (/[\\'"[\]]/.test(cleaned)) {
                                        cleaned = cleaned.replace(/[\\'"[\]]/g, '');
                                    }
                                    return cleaned.trim();
                                }
                                return val ? String(val).trim() : '';
                            };
                            
                            if (Array.isArray(value)) {
                                const flattened = flattenArray(value);
                                const allValues = [];
                                flattened.forEach(v => {
                                    const cleaned = cleanValue(v);
                                    if (cleaned.includes(',')) {
                                        cleaned.split(',').forEach(item => {
                                            const trimmed = item.trim();
                                            if (trimmed) allValues.push(trimmed);
                                        });
                                    } else if (cleaned) {
                                        allValues.push(cleaned);
                                    }
                                });
                                value = [...new Set(allValues)].filter(v => v && v !== '');
                            } else if (typeof value === 'string') {
                                const parsed = deepParse(value);
                                if (Array.isArray(parsed)) {
                                    const flattened = flattenArray(parsed);
                                    const allValues = [];
                                    flattened.forEach(v => {
                                        const cleaned = cleanValue(v);
                                        if (cleaned.includes(',')) {
                                            cleaned.split(',').forEach(item => {
                                                const trimmed = item.trim();
                                                if (trimmed) allValues.push(trimmed);
                                            });
                                        } else if (cleaned) {
                                            allValues.push(cleaned);
                                        }
                                    });
                                    value = [...new Set(allValues)].filter(v => v && v !== '');
                                } else {
                                    const cleaned = cleanValue(parsed);
                                    value = cleaned ? [cleaned] : [];
                                }
                            } else {
                                value = value ? [String(value)] : [];
                            }
                        }
                        
                        if (JSON.stringify(this.formData[key]) !== JSON.stringify(value)) {
                            this.formData[key] = value;
                        }
                    });
                }

                this.syncFormDataToVeeValidate();
                this.form_data_loading = false;
                this.$forceUpdate();
            });
        },

        handleRegistration(data) {
            console.log('handleRegistration called with data:', data);
            console.log('Form data:', this.formData);
            
            // Manual validation for required fields
            const requiredFields = this.enabledFields.filter(field => field.required);
            const missingFields = [];
            
            for (const field of requiredFields) {
                const value = this.formData[field.column_id];
                // Allow 0 and "0" as valid values
                if (value !== 0 && value !== '0' && !value) {
                    missingFields.push(field.label || field.column_id);
                }
            }
            
            if (missingFields.length > 0) {
                this.alert_type = 'Error';
                this.alert_message = `Please fill required fields: ${missingFields.join(', ')}`;
                this.$refs.alert_model.openModel();
                return;
            }
            
            const contact = this.searchResponse.contact;
            const contactId = contact && (contact.id || contact.contact_id);

            if (!contact || !contactId) {
                console.error('No valid contact found:', contact);
                this.alert_type = 'Error';
                this.alert_message = 'No valid contact found. Please wait for contact data to load or refresh the page.';
                this.$refs.alert_model.openModel();
                return;
            }

            console.log('Form validation passed, proceeding with submission');
            this.btn_loading = true;

            const formattedData = { ...data };

            // Handle phone numbers with country code
            const mobileFields = ['mobile2', 'whatsapp', 'mobile_new'];
            mobileFields.forEach(fieldId => {
                if (formattedData[fieldId] && formattedData[fieldId].toString().length > 0) {
                    const parts = this.buildPhonePartsForSubmit(fieldId, formattedData[fieldId]);
                    formattedData[fieldId] = parts.local;
                    formattedData[fieldId + '_country_code'] = parts.code;
                }
            });

            // Add all basic fields to formattedData (they will be stored in custom_fields if not fillable)
            if (this.basicFields && this.basicFields.length > 0) {
                this.basicFields.forEach(field => {
                    const fieldId = field.column_id;
                    if (this.formData[fieldId] !== undefined && this.formData[fieldId] !== null) {
                        let value = this.formData[fieldId];
                        
                        // Clean checkbox values to prevent nested JSON
                        if (field.type === 'Checkbox') {
                            if (Array.isArray(value)) {
                                const allValues = [];
                                value.forEach(v => {
                                    if (typeof v === 'string') {
                                        let cleaned = v;
                                        while (/[\\'"[\]]/.test(cleaned)) {
                                            cleaned = cleaned.replace(/[\\'"[\]]/g, '');
                                        }
                                        if (cleaned.includes(',')) {
                                            cleaned.split(',').forEach(item => {
                                                const trimmed = item.trim();
                                                if (trimmed) allValues.push(trimmed);
                                            });
                                        } else if (cleaned.trim()) {
                                            allValues.push(cleaned.trim());
                                        }
                                    } else if (v) {
                                        allValues.push(String(v).trim());
                                    }
                                });
                                value = [...new Set(allValues)].filter(v => v && v !== '');
                            } else if (value) {
                                let cleaned = String(value);
                                while (/[\\'"[\]]/.test(cleaned)) {
                                    cleaned = cleaned.replace(/[\\'"[\]]/g, '');
                                }
                                value = [cleaned.trim()].filter(v => v);
                            } else {
                                value = [];
                            }
                        }
                        
                        // Basic fields with b_ prefix should be sent in the request
                        formattedData[fieldId] = value;
                    }
                });
            }
            
            // Add all form fields to formattedData, cleaning checkbox values
            this.fields.forEach(field => {
                const fieldId = field.column_id;
                if (this.formData[fieldId] !== undefined && this.formData[fieldId] !== null) {
                    let value = this.formData[fieldId];
                    
                    // Clean checkbox values to prevent nested JSON
                    if (field.type === 'Checkbox') {
                        if (Array.isArray(value)) {
                            // Flatten and split comma-separated strings
                            const allValues = [];
                            value.forEach(v => {
                                if (typeof v === 'string') {
                                    // Remove ALL escape characters, quotes, and brackets
                                    let cleaned = v;
                                    while (/[\\'"[\]]/.test(cleaned)) {
                                        cleaned = cleaned.replace(/[\\'"[\]]/g, '');
                                    }
                                    // Split by comma in case multiple values are in one string
                                    if (cleaned.includes(',')) {
                                        cleaned.split(',').forEach(item => {
                                            const trimmed = item.trim();
                                            if (trimmed) allValues.push(trimmed);
                                        });
                                    } else if (cleaned.trim()) {
                                        allValues.push(cleaned.trim());
                                    }
                                } else if (v) {
                                    allValues.push(String(v).trim());
                                }
                            });
                            // Remove duplicates and empty values
                            value = [...new Set(allValues)].filter(v => v && v !== '');
                        } else if (value) {
                            let cleaned = String(value);
                            while (/[\\'"[\]]/.test(cleaned)) {
                                cleaned = cleaned.replace(/[\\'"[\]]/g, '');
                            }
                            value = [cleaned.trim()].filter(v => v);
                        } else {
                            value = [];
                        }
                        console.log(`Cleaned ${fieldId} for submission:`, value);
                    }
                    
                    formattedData[fieldId] = value;
                }
            });

            // Collect all custom field values (any field not in system fields)
            // Note: Basic fields (b_*) are now stored in separate columns, NOT in custom_fields
            const systemFields = [
                'id', 'contact_id', 'campaign_id', '_token', 'questians_responses',
                'name', 'mobile', 'comments', 'status', 'calling_status',
                'district_id', 'zone_id', 'unit_id', 'wing', 'gender',
                'mobile2', 'whatsapp', 'mobile_new', 'mobile2_country_code', 'whatsapp_country_code', 'country_code',
                'assigned_mobile', 'assigned_user_id', 'background_summery', 'created_at', 'deleted_at', 'designation',
                'food_needed', 'is_member', 'job', 'member_id', 'mentor_id', 'place', 'registration_status', 'self_confirmation_status', 'will_come', 'will_arrive_at', 'transportation',
                // Basic fields are now separate columns, not custom fields
                'b_name', 'b_gender', 'b_age', 'b_mobile', 'b_whatsapp', 'b_place', 'b_district', 'b_zone', 'b_unit', 'b_wing', 'b_membership_status', 'b_member_id', 'b_job', 'b_education', 'b_institution', 'b_background', 'b_org_positions', 'b_org_departments'
            ];
            const customFields = {};
            
            // Add only non-system, non-basic custom fields
            this.fields.forEach(field => {
                if (!systemFields.includes(field.column_id) && !field.column_id.startsWith('b_')) {
                    let value = this.formData[field.column_id];
                    // Clean checkbox values before saving - ensure they're simple arrays
                    if (field.type === 'Checkbox') {
                        if (Array.isArray(value)) {
                            // Flatten and split comma-separated strings
                            const allValues = [];
                            value.forEach(v => {
                                if (typeof v === 'string') {
                                    let cleaned = v;
                                    while (/[\\'"[\]]/.test(cleaned)) {
                                        cleaned = cleaned.replace(/[\\'"[\]]/g, '');
                                    }
                                    if (cleaned.includes(',')) {
                                        cleaned.split(',').forEach(item => {
                                            const trimmed = item.trim();
                                            if (trimmed) allValues.push(trimmed);
                                        });
                                    } else if (cleaned.trim()) {
                                        allValues.push(cleaned.trim());
                                    }
                                } else if (v) {
                                    allValues.push(String(v).trim());
                                }
                            });
                            value = [...new Set(allValues)].filter(v => v && v !== '');
                        } else if (value) {
                            let cleaned = String(value);
                            while (/[\\'"[\]]/.test(cleaned)) {
                                cleaned = cleaned.replace(/[\\'"[\]]/g, '');
                            }
                            value = [cleaned.trim()].filter(v => v);
                        } else {
                            value = [];
                        }
                    }
                    customFields[field.column_id] = value;
                }
            });
            formattedData.custom_fields = customFields;

            // IMPORTANT: Send values as-is, NOT converting to labels
            formattedData.id = contactId;
            formattedData.contact_id = contactId;
            formattedData.campaign_id = contact.campaign_id || this.$route.params.id;
            formattedData.questians_responses = this.questians_responses;

            console.log('Submitting form data:', formattedData);

            UserService.authPostRequest("v2/store-campign-response", formattedData).then(
                (response) => {
                    if (response.data.status == "success") {
                        this.alertRedirectRoute = "/call-follow-up-v2/" + this.$route.params.id;
                        this.pending_contacts = response.data.data.pending_contacts;
                        this.responseData.target = response.data.data.target;
                        this.responseData.balance = response.data.data.balance;
                        this.responseData.all_contacts = response.data.data.all_contacts;
                        this.alert_type = "Success";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.searchResponse.contact = '';
                        this.search_qry = '';
                        this.btn_loading = false;
                    } else if (response.data.status == "warning") {
                        this.alertRedirectRoute = '';
                        this.alert_type = "Warning";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btn_loading = false;
                    } else {
                        this.alertRedirectRoute = '';
                        this.alert_type = "Error";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btn_loading = false;
                    }
                },
                (error) => {
                    this.btn_loading = false;
                    this.alertRedirectRoute = '';
                    this.alert_type = 'Error';
                    this.alert_message =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        'An error occurred while saving the form';
                    this.$refs.alert_model.openModel();
                }
            );
        },

        mapCallingStatus(value) {
            if (value === null || value === undefined || value === '') return '';

            const valueStr = String(value).trim();
            console.log('Mapping calling_status:', valueStr);

            if (!Array.isArray(this.status_list) || this.status_list.length === 0) {
                console.log('Status list not loaded yet');
                this.formData.calling_status_temp = valueStr;
                return '';
            }

            console.log('Available status options:', this.status_list);

            // Try exact match
            const foundByValue = this.status_list.find(opt => {
                return String(opt.value || '') === valueStr ||
                       String(opt.item_value || '') === valueStr ||
                       String(opt.id || '') === valueStr;
            });

            if (foundByValue) {
                const result = foundByValue.value || foundByValue.item_value || foundByValue.id;
                console.log('Found by value match:', result);
                return String(result);
            }

            // Try label match
            const lower = valueStr.toLowerCase();
            const foundByLabel = this.status_list.find(opt => {
                const optLabel = String(opt.label || '').toLowerCase();
                const optName = String(opt.name || '').toLowerCase();
                return optLabel === lower || optName === lower || optLabel.includes(lower);
            });

            if (foundByLabel) {
                const result = foundByLabel.value || foundByLabel.item_value || foundByLabel.id;
                console.log('Found by label match:', result);
                return String(result);
            }

            console.warn('No matching calling_status found for:', valueStr);
            this.formData.calling_status_temp = valueStr;
            return '';
        },

        mapBackendFieldType(backendType) {
            if (!backendType) return 'text';

            switch (backendType.toUpperCase()) {
                case 'RADIO': return 'Radio';
                case 'SELECT': return 'Select';
                case 'CHECKBOX': return 'Checkbox';
                case 'NUMBER': return 'Number';
                case 'TEXTAREA': return 'textarea';
                case 'DATETIME': return 'datetime-local';
                case 'TIME': return 'time';
                case 'TEXT': return 'text';
                default: return 'text';
            }
        },

        determineFieldType(columnId) {
            // Fallback method when backend doesn't specify field type
            switch (columnId) {
                case 'gender':
                case 'b_gender':
                case 'district_id':
                case 'b_district':
                case 'zone_id':
                case 'b_zone':
                case 'unit_id':
                case 'b_unit':
                case 'calling_status':
                case 'wing':
                case 'b_wing':
                    return 'Select';
                case 'pr_listener':
                case 'finance':
                case 'mobile_changed':
                case 'registration_status':
                case 'self_confirmation_status':
                case 'participation':
                case 'food_needed':
                case 'visit_status':
                case 'b_membership_status':
                    return 'Radio'; // Default fallback, but backend type takes precedence
                case 'mobile2':
                case 'whatsapp':
                case 'mobile_new':
                case 'b_mobile':
                case 'b_whatsapp':
                case 'b_age':
                    return 'Number';
                case 'pr_opinion':
                case 'pr_help_needed':
                case 'comments':
                case 'b_background':
                    return 'textarea';
                default:
                    return 'text';
            }
        },

        // Helper methods
        getComboboxValues(code, id = null) {
            return new Promise((resolve, reject) => {
                UserService.getCombobox({ code: code, type_id: id }).then(
                    (response) => {
                        switch (code) {
                            case "CALL_CAMPAIGN_STATUS":
                                this.status_list = response.data.data.list.options || [];
                                console.log('CALL_CAMPAIGN_STATUS loaded:', this.status_list);

                                if (this.formData.calling_status_temp) {
                                    const mapped = this.mapCallingStatus(this.formData.calling_status_temp);
                                    if (mapped) {
                                        this.formData.calling_status = mapped;
                                        this.$nextTick(() => {
                                            this.$forceUpdate();
                                        });
                                    }
                                }
                                break;
                            case "COUNTRY_CODE":
                                this.country_code_list = response.data.data.list.options || [];
                                break;
                        }
                        resolve();
                    },
                    () => {
                        this.loading = false;
                        reject();
                    }
                );
            });
        },

        fetchZones(districtId) {
            if (!districtId) {
                this.zone_list = [];
                this.unit_list = [];
                return;
            }

            const data = { district_id: districtId };
            const existingZoneId = this.formData.zone_id;

            UserService.authPostRequest('get-zone-by-id', data).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.zone_list = response.data.data.list || [];
                        if (existingZoneId && this.zone_list.find(zone => zone.id == existingZoneId)) {
                            this.formData.zone_id = existingZoneId;
                            this.fetchUnits(existingZoneId);
                        } else {
                            this.unit_list = [];
                            this.formData.zone_id = '';
                            this.formData.unit_id = '';
                        }
                    }
                },
                () => {
                    this.zone_list = [];
                    this.unit_list = [];
                }
            );
        },

        fetchUnits(zoneId) {
            if (!zoneId) {
                this.unit_list = [];
                return;
            }

            const data = { zone_id: zoneId };
            const existingUnitId = this.formData.unit_id;

            UserService.authPostRequest('get-unit-by-id', data).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.unit_list = response.data.data.list || [];
                        if (existingUnitId && this.unit_list.find(unit => unit.id == existingUnitId)) {
                            this.formData.unit_id = existingUnitId;
                        } else {
                            this.formData.unit_id = '';
                        }
                    }
                },
                () => {
                    this.unit_list = [];
                    this.formData.unit_id = '';
                }
            );
        },

        onDistrictChange(districtId) {
            this.fetchZones(districtId);
        },

        onZoneChange(zoneId) {
            this.fetchUnits(zoneId);
        },

        handleEditDistrictZoneChange(fieldColumnId, event) {
            const newValue = event.target.value;
            
            if (fieldColumnId === 'b_district') {
                // Extract district ID from value (could be "imported:Name" or numeric ID)
                if (!newValue || String(newValue).startsWith('imported:')) {
                    // Can't fetch zones for imported names or empty selection, clear zones
                    this.zone_list = [];
                    this.unit_list = [];
                    if (this.editBasicFormData.b_zone) {
                        this.editBasicFormData.b_zone = '';
                    }
                    if (this.editBasicFormData.b_unit) {
                        this.editBasicFormData.b_unit = '';
                    }
                    return;
                }
                // Use numeric district ID to fetch zones
                this.fetchZones(newValue);
                // Clear zone and unit selections when district changes
                if (this.editBasicFormData.b_zone) {
                    this.editBasicFormData.b_zone = '';
                }
                if (this.editBasicFormData.b_unit) {
                    this.editBasicFormData.b_unit = '';
                }
            } else if (fieldColumnId === 'b_zone') {
                // Extract zone ID from value (could be "imported:Name" or numeric ID)
                if (!newValue || String(newValue).startsWith('imported:')) {
                    // Can't fetch units for imported names or empty selection, clear units
                    this.unit_list = [];
                    if (this.editBasicFormData.b_unit) {
                        this.editBasicFormData.b_unit = '';
                    }
                    return;
                }
                // Use numeric zone ID to fetch units
                this.fetchUnits(newValue);
                // Clear unit selection when zone changes
                if (this.editBasicFormData.b_unit) {
                    this.editBasicFormData.b_unit = '';
                }
            }
        },

        // Phone field helpers
        setPhoneFieldValues(fieldId, rawValue) {
            const parsed = this.parsePhoneNumber(rawValue);
            if (!parsed) return;
            if (parsed.localNumber !== null && parsed.localNumber !== undefined) {
                this.formData[fieldId] = parsed.localNumber;
            }
            if (parsed.countryCode) {
                this.formData[fieldId + '_country_code'] = parsed.countryCode;
            } else if (!this.formData[fieldId + '_country_code']) {
                this.formData[fieldId + '_country_code'] = '+91';
            }
        },

        parsePhoneNumber(phoneString) {
            try {
                if (!phoneString) return null;
                const digitsOnly = phoneString.toString().replace(/\D/g, '');
                if (digitsOnly.length <= 10) {
                    return { countryCode: null, localNumber: digitsOnly };
                }
                const localNumber = digitsOnly.slice(-10);
                const countryDigits = digitsOnly.slice(0, digitsOnly.length - 10);
                const countryCode = countryDigits ? ('+' + countryDigits) : null;
                return { countryCode, localNumber };
            } catch (e) {
                return null;
            }
        },

        buildPhonePartsForSubmit(fieldId, rawValue) {
            const selectedCodeRaw = this.formData[fieldId + '_country_code'] || '+91';
            const selectedCodeDigits = String(selectedCodeRaw).replace(/\D/g, '') || '91';
            let digits = (rawValue ?? '').toString().replace(/\D/g, '');
            if (selectedCodeDigits && digits.startsWith(selectedCodeDigits)) {
                digits = digits.slice(selectedCodeDigits.length);
            }
            if (digits.length > 10) digits = digits.slice(-10);
            return { local: digits, code: selectedCodeDigits };
        },

        // Build dial / WhatsApp numbers for the header actions
        getHeaderContactPhoneInfo() {
            // Determine the primary mobile shown in the header
            const contact = this.searchResponse?.contact || {};
            const directory = this.directoryContact || {};

            const rawMobile =
                this.getBasicDisplayValue('b_mobile', 'mobile') ||
                this.formData.b_mobile ||
                this.formData.mobile ||
                contact.b_mobile ||
                contact.mobile ||
                directory.mobile ||
                '';

            if (!rawMobile) {
                return null;
            }

            const rawStr = String(rawMobile).trim();
            const digitsOnly = rawStr.replace(/\D/g, '');
            const hasPlus = rawStr.startsWith('+');

            // Try to parse country code and local number from the raw string
            const parsed = this.parsePhoneNumber(rawStr) || {};

            let countryCode = parsed.countryCode || null;
            let localNumber = parsed.localNumber || null;

            // Override / supplement with explicit country code fields when available
            const explicitCode =
                this.getBasicFieldValue('b_mobile_country_code') ||
                contact.b_mobile_country_code ||
                contact.country_code ||
                directory.country_code ||
                null;

            if (explicitCode) {
                countryCode = explicitCode;
            }

            if (!localNumber) {
                if (countryCode) {
                    const codeDigitsTmp = String(countryCode).replace(/\D/g, '');
                    if (codeDigitsTmp && digitsOnly.startsWith(codeDigitsTmp)) {
                        localNumber = digitsOnly.slice(codeDigitsTmp.length);
                    } else if (digitsOnly.length > 10) {
                        localNumber = digitsOnly.slice(-10);
                    } else {
                        localNumber = digitsOnly;
                    }
                } else {
                    localNumber = digitsOnly;
                }
            }

            const countryCodeDigits = countryCode ? String(countryCode).replace(/\D/g, '') : null;

            return {
                raw: rawStr,
                digitsOnly,
                hasPlus,
                countryCodeDigits,
                localNumber: String(localNumber || ''),
            };
        },

        getHeaderDialNumber() {
            const info = this.getHeaderContactPhoneInfo();
            if (!info || !info.localNumber) {
                return '';
            }

            const userCodeDigits = this.currentUser && this.currentUser.country_code
                ? String(this.currentUser.country_code).replace(/\D/g, '')
                : null;

            const contactCodeDigits = info.countryCodeDigits || userCodeDigits || null;

            // If we still don't know the country code, return the raw number as-is
            if (!contactCodeDigits) {
                return info.raw;
            }

            // When caller and contact are from the same country, use local format with leading 0
            if (userCodeDigits && userCodeDigits === contactCodeDigits) {
                let local = info.localNumber.replace(/\D/g, '');
                if (!local.startsWith('0')) {
                    local = '0' + local;
                }
                return local;
            }

            // Different countries: dial with full international format +<code><number>
            let localIntl = info.localNumber.replace(/\D/g, '');
            if (localIntl.startsWith('0')) {
                localIntl = localIntl.substring(1);
            }

            return '+' + contactCodeDigits + localIntl;
        },

        getHeaderWhatsappHref() {
            const info = this.getHeaderContactPhoneInfo();
            if (!info || !info.localNumber) {
                return '';
            }

            const contact = this.searchResponse?.contact || {};
            const directory = this.directoryContact || {};

            // Prefer explicit WhatsApp country code if present; fall back to mobile code, then user code, then India
            let whatsappCode =
                contact.whatsapp_country_code ||
                directory.whatsapp_country_code ||
                info.countryCodeDigits ||
                (this.currentUser && this.currentUser.country_code) ||
                '91';

            const whatsappCodeDigits = String(whatsappCode).replace(/\D/g, '') || '91';

            let local = info.localNumber.replace(/\D/g, '');
            // WhatsApp requires international format without leading zero
            if (local.startsWith('0')) {
                local = local.substring(1);
            }

            return 'https://wa.me/' + whatsappCodeDigits + local + '?text=';
        },

        mobileToWhatsapp(mobileNumber) {
            const cleanNumber = mobileNumber.replace(/\D/g, '');
            if (cleanNumber.length === 10) {
                return '91' + cleanNumber;
            } else {
                return cleanNumber;
            }
        },

        // Navigation helpers
        displayAll() {
            this.search_qry = '';
            this.searchResponse.contact = '';
            this.searchResponse.message = '';
        },

        gotoReport(mobile) {
            this.$router.push('/call-follow-up-V2/' + this.responseData.campign.reporting_campaign_id + '/' + mobile);
        },

        goToMentorManagement() {
            // Navigate to mentor management page with campaign_id
            const campaignId = this.responseData.campign.id;
            this.$router.push('/call-follow-up-v2/' + campaignId + '/assign-mentors');
        },

        gotoEdit(mobile) {
            const route = '/call-follow-up-edit-v2/' + this.$route.params.id + '/' + mobile;
            this.$router.push(route);
        },

        gotoEditWithData(memberData) {
            // If coming from report page, do nothing (contacts are not clickable)
            if (this.isFromReport) {
                return;
            }
            // Otherwise, navigate to edit page as usual
            localStorage.setItem('editMemberData', JSON.stringify(memberData));
            const contactId = memberData.id;
            const route = '/call-follow-up-edit-v2/' + this.$route.params.id + '/' + contactId;
            this.$router.push(route);
        },

        loadStoredMemberData(memberData) {
            this.form_data_loading = true;
            this.searchResponse.contact = {
                contact_id: memberData.id,
                id: memberData.id,
                name: memberData.name || 'Stored Contact',
                mobile: memberData.assigned_mobile || memberData.mobile,
                campaign_id: this.$route.params.id,
                ...memberData
            };
            this.search_qry = memberData.assigned_mobile || memberData.mobile || memberData.id;

            if (this.fields.length === 0) {
                this.tempMemberData = memberData;
                return;
            }

            this.populateFormDirectly(memberData);
            
            // Also fetch fresh data from API to get directory_contact and value_differences
            this.fetchDirectoryContactData(memberData.id || memberData.assigned_mobile || memberData.mobile);
        },
        
        // Fetch directory contact data and value differences from API
        fetchDirectoryContactData(contactIdOrMobile) {
            let data = {
                q: contactIdOrMobile,
                id: this.$route.params.id,
            };
            
            UserService.authPostRequest('v2/get-call-campign-contact', data).then(
                (response) => {
                    if (response.data.status == 'success' && response.data.data) {
                        // Update directory contact and value differences
                        this.directoryContact = response.data.data.directory_contact || null;
                        this.valueDifferences = response.data.data.value_differences || {};
                        this.confirmedValues = {};
                        
                        // Also update the contact data if available
                        if (response.data.data.contact) {
                            // Merge fresh API data into existing searchResponse.contact
                            Object.assign(this.searchResponse.contact, response.data.data.contact);
                        }
                        
                        console.log('Directory contact loaded:', this.directoryContact);
                        console.log('Value differences loaded:', this.valueDifferences);
                    }
                },
                (error) => {
                    console.error('Error fetching directory contact data:', error);
                }
            );
        },

        populateFormDirectly(memberData) {
            // Contact-level fields (not in campaign field list)
            if (memberData.reference_id !== undefined && memberData.reference_id !== null && memberData.reference_id !== '') {
                this.formData.reference_id = String(memberData.reference_id);
            }
            // Populate basic fields first (now stored in separate columns)
            if (this.basicFields && this.basicFields.length > 0) {
                this.basicFields.forEach(field => {
                    const columnId = field.column_id;
                    let value = memberData[columnId];
                    
                    // Basic fields are now stored in separate columns, not in custom_fields
                    
                    if (value !== undefined && value !== null && value !== '') {
                        if (field.type === 'Checkbox') {
                            if (Array.isArray(value)) {
                                const allValues = [];
                                value.forEach(v => {
                                    const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                    if (cleaned.includes(',')) {
                                        cleaned.split(',').forEach(item => {
                                            if (item.trim()) allValues.push(item.trim());
                                        });
                                    } else if (cleaned) {
                                        allValues.push(cleaned);
                                    }
                                });
                                this.formData[columnId] = [...new Set(allValues)];
                            } else if (typeof value === 'string') {
                                try {
                                    let parsed = JSON.parse(value);
                                    while (typeof parsed === 'string' && (parsed.startsWith('[') || parsed.startsWith('"'))) {
                                        try {
                                            parsed = JSON.parse(parsed);
                                        } catch (e) {
                                            break;
                                        }
                                    }
                                    if (Array.isArray(parsed)) {
                                        const allValues = [];
                                        parsed.forEach(v => {
                                            const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                            if (cleaned.includes(',')) {
                                                cleaned.split(',').forEach(item => {
                                                    if (item.trim()) allValues.push(item.trim());
                                                });
                                            } else if (cleaned) {
                                                allValues.push(cleaned);
                                            }
                                        });
                                        this.formData[columnId] = [...new Set(allValues)];
                                    } else {
                                        const cleaned = typeof parsed === 'string' ? parsed.replace(/[\\'"[\]]/g, '').trim() : String(parsed).trim();
                                        this.formData[columnId] = cleaned ? [cleaned] : [];
                                    }
                                } catch (e) {
                                    const cleaned = value.replace(/[\\'"[\]]/g, '').trim();
                                    this.formData[columnId] = cleaned.includes(',') 
                                        ? cleaned.split(',').map(v => v.trim()).filter(v => v)
                                        : [cleaned].filter(v => v);
                                }
                            } else {
                                this.formData[columnId] = [String(value)];
                            }
                        } else {
                            this.formData[columnId] = String(value);
                        }
                    }
                });
            }
            
            // Then populate regular fields
            this.fields.forEach(field => {
                const columnId = field.column_id;
                let value = memberData[columnId];
                
                if (value !== undefined && value !== null && value !== '') {
                    // Handle checkbox fields - keep them as arrays
                    if (field.type === 'Checkbox') {
                        if (Array.isArray(value)) {
                            // Already an array, just clean it
                            const allValues = [];
                            value.forEach(v => {
                                const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                if (cleaned.includes(',')) {
                                    cleaned.split(',').forEach(item => {
                                        if (item.trim()) allValues.push(item.trim());
                                    });
                                } else if (cleaned) {
                                    allValues.push(cleaned);
                                }
                            });
                            this.formData[columnId] = [...new Set(allValues)];
                        } else if (typeof value === 'string') {
                            // Try to parse as JSON array
                            try {
                                let parsed = JSON.parse(value);
                                // Keep parsing if still a string
                                while (typeof parsed === 'string' && (parsed.startsWith('[') || parsed.startsWith('"'))) {
                                    try {
                                        parsed = JSON.parse(parsed);
                                    } catch (e) {
                                        break;
                                    }
                                }
                                // Now clean the parsed value
                                if (Array.isArray(parsed)) {
                                    const allValues = [];
                                    parsed.forEach(v => {
                                        const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                        if (cleaned.includes(',')) {
                                            cleaned.split(',').forEach(item => {
                                                if (item.trim()) allValues.push(item.trim());
                                            });
                                        } else if (cleaned) {
                                            allValues.push(cleaned);
                                        }
                                    });
                                    this.formData[columnId] = [...new Set(allValues)];
                                } else {
                                    const cleaned = typeof parsed === 'string' ? parsed.replace(/[\\'"[\]]/g, '').trim() : String(parsed).trim();
                                    this.formData[columnId] = cleaned ? [cleaned] : [];
                                }
                            } catch (e) {
                                // Not JSON, split by comma
                                const cleaned = value.replace(/[\\'"[\]]/g, '').trim();
                                this.formData[columnId] = cleaned.includes(',') 
                                    ? cleaned.split(',').map(v => v.trim()).filter(v => v)
                                    : [cleaned].filter(v => v);
                            }
                        } else {
                            this.formData[columnId] = [String(value)];
                        }
                    } else {
                        // For non-checkbox fields, convert to string
                        this.formData[columnId] = String(value);
                    }
                }
            });
            // Populate custom fields
            if (memberData.custom_fields) {
                let customFields = memberData.custom_fields;
                
                // Parse if it's a string
                if (typeof customFields === 'string') {
                    try {
                        customFields = JSON.parse(customFields);
                    } catch (e) {
                        console.error('Failed to parse custom_fields:', e);
                        customFields = {};
                    }
                }
                
                if (customFields && typeof customFields === 'object') {
                    Object.keys(customFields).forEach(key => {
                        // Skip basic fields (b_*) as they are now stored in separate columns
                        if (key.startsWith('b_')) {
                            return;
                        }
                        
                        const field = this.fields.find(f => f.column_id === key);
                        let value = customFields[key];
                        
                        // Handle checkbox fields specially
                        if (field && field.type === 'Checkbox') {
                            if (Array.isArray(value)) {
                                const allValues = [];
                                value.forEach(v => {
                                    const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                    if (cleaned.includes(',')) {
                                        cleaned.split(',').forEach(item => {
                                            if (item.trim()) allValues.push(item.trim());
                                        });
                                    } else if (cleaned) {
                                        allValues.push(cleaned);
                                    }
                                });
                                this.formData[key] = [...new Set(allValues)];
                            } else if (typeof value === 'string') {
                                try {
                                    let parsed = JSON.parse(value);
                                    while (typeof parsed === 'string' && (parsed.startsWith('[') || parsed.startsWith('"'))) {
                                        try {
                                            parsed = JSON.parse(parsed);
                                        } catch (e) {
                                            break;
                                        }
                                    }
                                    if (Array.isArray(parsed)) {
                                        const allValues = [];
                                        parsed.forEach(v => {
                                            const cleaned = typeof v === 'string' ? v.replace(/[\\'"[\]]/g, '').trim() : String(v).trim();
                                            if (cleaned.includes(',')) {
                                                cleaned.split(',').forEach(item => {
                                                    if (item.trim()) allValues.push(item.trim());
                                                });
                                            } else if (cleaned) {
                                                allValues.push(cleaned);
                                            }
                                        });
                                        this.formData[key] = [...new Set(allValues)];
                                    } else {
                                        const cleaned = typeof parsed === 'string' ? parsed.replace(/[\\'"[\]]/g, '').trim() : String(parsed).trim();
                                        this.formData[key] = cleaned ? [cleaned] : [];
                                    }
                                } catch (e) {
                                    const cleaned = value.replace(/[\\'"[\]]/g, '').trim();
                                    this.formData[key] = cleaned.includes(',') 
                                        ? cleaned.split(',').map(v => v.trim()).filter(v => v)
                                        : [cleaned].filter(v => v);
                                }
                            } else {
                                this.formData[key] = value ? [String(value)] : [];
                            }
                        } else {
                            this.formData[key] = value;
                        }
                    });
                }
            }
            // Handle cascading dropdowns for both basic and regular fields
            const districtId = memberData.b_district || memberData.district_id;
            const zoneId = memberData.b_zone || memberData.zone_id;
            const unitId = memberData.b_unit || memberData.unit_id;
            
            if (districtId) {
                this.formData.b_district = memberData.b_district || '';
                this.formData.district_id = memberData.district_id || '';
                this.fetchZones(districtId);
            }

            if (zoneId) {
                setTimeout(() => {
                    this.formData.b_zone = memberData.b_zone || '';
                    this.formData.zone_id = memberData.zone_id || '';
                    if (unitId) {
                        this.fetchUnits(zoneId);
                        setTimeout(() => {
                            this.formData.b_unit = memberData.b_unit || '';
                            this.formData.unit_id = memberData.unit_id || '';
                        }, 500);
                    }
                }, 500);
            }

            this.$nextTick(() => {
                this.syncFormDataToVeeValidate();
                this.form_data_loading = false;
            });
        },

        syncFormDataToVeeValidate() {
            this.fields.forEach(field => {
                const columnId = field.column_id;
                let value = this.formData[columnId];
                // For SELECT fields, ensure we send the actual option value, not boolean
                if (field.type === 'Select' && Array.isArray(field.options)) {
                    // If value is boolean, map to option value
                    if (typeof value === 'boolean') {
                        const opt = field.options.find(opt => opt.value === 'Yes' && value === true || opt.value === 'No' && value === false || opt.value === '1' && value === true || opt.value === '0' && value === false);
                        if (opt) value = opt.value;
                    }
                    this.formData[columnId] = value;
                } else {
                    this.formData[columnId] = value;
                }
            });
            this.$forceUpdate();
        },

        searchWithValidation(contactId) {
            this.search(contactId);
        },

        showContactAlternativesFromResponse(validContacts, message) {
            this.validContactsList = validContacts.slice(0, 10);
            this.showContactAlternativesList = true;

            let alternativeMessage = message || `Contact ID ${this.search_qry} not found.`;
            alternativeMessage += `\n\nAvailable contacts are shown below. Click on any contact to select it.`;

            this.alert_type = 'Warning';
            this.alert_message = alternativeMessage;
            this.$refs.alert_model.openModel();
        },

        fetchValidContacts() {
            const data = { campaign_id: this.$route.params.id };

            UserService.authPostRequest('v2/get-valid-contacts', data).then(
                (response) => {
                    if (response.data.status === 'success' && response.data.data.contacts) {
                        this.validContactsList = response.data.data.contacts.slice(0, 10);
                        this.showContactAlternativesList = true;
                    }
                },
                (error) => {
                    console.log('Failed to fetch valid contacts:', error);
                }
            );
        },

        selectValidContact(contact) {
            this.hideContactAlternatives();
            this.search_qry = contact.id;
            this.search(contact.id);
        },

        hideContactAlternatives() {
            this.showContactAlternativesList = false;
            this.validContactsList = [];
        },

        // Checkbox helper methods
        isCheckboxChecked(fieldId, optionValue) {
            const fieldValue = this.formData[fieldId];
            console.log(`Checking ${fieldId} for ${optionValue}:`, fieldValue);

            // If field value is an array, check if option is in array
            if (Array.isArray(fieldValue)) {
                // Normalize and split comma-separated values
                const allNormalizedValues = [];
                fieldValue.forEach(val => {
                    if (typeof val === 'string') {
                        // Remove all backslashes, quotes, and brackets
                        let cleaned = val.replace(/[\\'"[\]]/g, '').trim();
                        // Split by comma if it contains commas
                        if (cleaned.includes(',')) {
                            cleaned.split(',').forEach(item => {
                                const trimmed = item.trim();
                                if (trimmed) allNormalizedValues.push(trimmed);
                            });
                        } else if (cleaned) {
                            allNormalizedValues.push(cleaned);
                        }
                    } else if (val) {
                        allNormalizedValues.push(String(val));
                    }
                });
                
                // Also normalize the option value we're checking for
                const normalizedOption = optionValue.replace(/[\\'"[\]]/g, '').trim();
                
                const isChecked = allNormalizedValues.includes(normalizedOption);
                console.log(`Normalized values:`, allNormalizedValues);
                console.log(`Checking for normalized:`, normalizedOption);
                console.log(`Array check result: ${isChecked}`);
                return isChecked;
            }

            // If field value is a single value, check exact match
            const normalizedValue = typeof fieldValue === 'string' ? fieldValue.replace(/[\\'"[\]]/g, '').trim() : String(fieldValue);
            const normalizedOption = optionValue.replace(/[\\'"[\]]/g, '').trim();
            const isChecked = normalizedValue === normalizedOption;
            console.log(`Single value check result: ${isChecked}`);
            return isChecked;
        },

        handleCheckboxChange(fieldId, optionValue, event) {
            const isChecked = event.target.checked;
            let currentValue = this.formData[fieldId];
            
            console.log(`Checkbox change - Field: ${fieldId}, Option: ${optionValue}, Checked: ${isChecked}`);
            console.log(`Current value before change:`, currentValue);

            // Initialize as array if not set
            if (!currentValue || !Array.isArray(currentValue)) {
                currentValue = [];
            }
            
            // Clean the current array - remove any comma-separated strings and flatten
            const cleanedCurrentValue = [];
            currentValue.forEach(val => {
                if (typeof val === 'string') {
                    const cleaned = val.replace(/[\\'"[\]]/g, '').trim();
                    if (cleaned.includes(',')) {
                        cleaned.split(',').forEach(item => {
                            const trimmed = item.trim();
                            if (trimmed) cleanedCurrentValue.push(trimmed);
                        });
                    } else if (cleaned) {
                        cleanedCurrentValue.push(cleaned);
                    }
                } else if (val) {
                    cleanedCurrentValue.push(String(val));
                }
            });

            if (isChecked) {
                // Add to array if not already present
                if (!cleanedCurrentValue.includes(optionValue)) {
                    cleanedCurrentValue.push(optionValue);
                }
            } else {
                // Remove from array (remove all instances)
                const filtered = cleanedCurrentValue.filter(v => v !== optionValue);
                cleanedCurrentValue.length = 0;
                cleanedCurrentValue.push(...filtered);
            }

            // Update the form data with cleaned array
            this.formData[fieldId] = cleanedCurrentValue;

            console.log(`Checkbox ${fieldId} updated to:`, this.formData[fieldId]);
        },

        // Check if featured question is configured
        hasFeaturedQuestion() {
            return this.responseData && this.responseData.campign && this.responseData.campign.featured_question_1;
        },

        // Get featured question value from contact (returns actual value or null)
        getFeaturedQuestionValue(contact) {
            if (!this.hasFeaturedQuestion()) {
                return null;
            }

            const featuredQuestionColumn = this.responseData.campign.featured_question_1;
            
            // Get the value from the contact object
            // Check both direct property and custom_fields
            let value = contact[featuredQuestionColumn];
            
            if (value === null || value === undefined || value === '') {
                // Try custom_fields if direct property doesn't exist
                if (contact.custom_fields && typeof contact.custom_fields === 'object') {
                    value = contact.custom_fields[featuredQuestionColumn];
                }
            }

            // Return the value as string, or null if not set
            return value !== null && value !== undefined && value !== '' ? String(value) : null;
        },

        // Get display value for featured question (only returns actual saved value)
        getFeaturedQuestionDisplayValue(contact) {
            // This method is only called when value exists (due to v-if condition)
            // So we can safely return the value
            return this.getFeaturedQuestionValue(contact);
        },

        // Get CSS class for featured question display (single dark color for all values)
        // eslint-disable-next-line no-unused-vars
        getFeaturedQuestionClass(contact) {
            // Use a single dark color for all featured question values
            return 'text-dark';
        },

        // Status Display Flag Checkers
        shouldShowStatusBadges() {
            return this.shouldShowRegistrationStatus() || 
                   this.shouldShowSelfConfirmationStatus() || 
                   this.shouldShowPaymentStatus();
        },

        shouldShowRegistrationStatus() {
            return this.responseData && 
                   this.responseData.campign && 
                   (this.responseData.campign.show_registration_status === true || 
                    this.responseData.campign.show_registration_status === 1 ||
                    this.responseData.campign.show_registration_status === '1');
        },

        shouldShowSelfConfirmationStatus() {
            return this.responseData && 
                   this.responseData.campign && 
                   (this.responseData.campign.show_self_confirmation_status === true || 
                    this.responseData.campign.show_self_confirmation_status === 1 ||
                    this.responseData.campign.show_self_confirmation_status === '1');
        },

        shouldShowPaymentStatus() {
            return this.responseData && 
                   this.responseData.campign && 
                   (this.responseData.campign.show_payment_status === true || 
                    this.responseData.campign.show_payment_status === 1 ||
                    this.responseData.campign.show_payment_status === '1');
        },

        // Registration Status Helpers
        getRegistrationStatusLabel(status) {
            if (!status) return '';
            const statusStr = String(status).toLowerCase().trim();
            
            // Map common registration status values
            if (statusStr.includes('register') && (statusStr.includes('yes') || statusStr.includes('done') || statusStr === 'y' || statusStr === '1')) {
                return 'Registered Professional';
            } else if (statusStr.includes('register') && (statusStr.includes('no') || statusStr.includes('not') || statusStr === 'n' || statusStr === '0')) {
                return 'Unregistered Professional';
            }
            
            // Return as-is if no match
            return status;
        },

        getRegistrationStatusClass(status) {
            if (!status) return 'status-badge-default';
            const statusStr = String(status).toLowerCase().trim();
            
            if (statusStr.includes('register') && (statusStr.includes('yes') || statusStr.includes('done') || statusStr === 'y' || statusStr === '1')) {
                return 'status-badge-registered';
            } else if (statusStr.includes('register') && (statusStr.includes('no') || statusStr.includes('not') || statusStr === 'n' || statusStr === '0')) {
                return 'status-badge-unregistered';
            }
            
            return 'status-badge-default';
        },

        getRegistrationStatusIcon(status) {
            if (!status) return 'briefcase-outline';
            const statusStr = String(status).toLowerCase().trim();
            
            if (statusStr.includes('register') && (statusStr.includes('yes') || statusStr.includes('done') || statusStr === 'y' || statusStr === '1')) {
                return 'briefcase';
            } else if (statusStr.includes('register') && (statusStr.includes('no') || statusStr.includes('not') || statusStr === 'n' || statusStr === '0')) {
                return 'briefcase-outline';
            }
            
            return 'briefcase-outline';
        },

        // Self Confirmation Status Helpers
        getSelfConfirmationStatusLabel(status) {
            if (!status) return '';
            const statusStr = String(status).toLowerCase().trim();
            
            if (statusStr === 'y' || statusStr === 'yes' || statusStr === '1' || statusStr === 'confirmed') {
                return 'Self Confirmed';
            } else if (statusStr === 'n' || statusStr === 'no' || statusStr === '0' || statusStr === 'not confirmed') {
                return 'Not Self Confirmed';
            }
            
            return status;
        },

        getSelfConfirmationStatusClass(status) {
            if (!status) return 'status-badge-default';
            const statusStr = String(status).toLowerCase().trim();
            
            if (statusStr === 'y' || statusStr === 'yes' || statusStr === '1' || statusStr === 'confirmed') {
                return 'status-badge-confirmed';
            } else if (statusStr === 'n' || statusStr === 'no' || statusStr === '0' || statusStr === 'not confirmed') {
                return 'status-badge-not-confirmed';
            }
            
            return 'status-badge-default';
        },

        // Payment Status Helpers
        getPaymentStatusLabel(status) {
            if (!status) return '';
            const statusStr = String(status).toLowerCase().trim();
            
            if (statusStr.includes('paid') || statusStr.includes('complete') || statusStr === 'y' || statusStr === '1') {
                return 'Paid';
            } else if (statusStr.includes('unpaid') || statusStr.includes('pending') || statusStr === 'n' || statusStr === '0') {
                return 'Unpaid';
            }
            
            return status;
        },

        getPaymentStatusClass(status) {
            if (!status) return 'status-badge-default';
            const statusStr = String(status).toLowerCase().trim();
            
            if (statusStr.includes('paid') || statusStr.includes('complete') || statusStr === 'y' || statusStr === '1') {
                return 'status-badge-paid';
            } else if (statusStr.includes('unpaid') || statusStr.includes('pending') || statusStr === 'n' || statusStr === '0') {
                return 'status-badge-unpaid';
            }
            
            return 'status-badge-default';
        }
    },
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
    font-size: 12px;
    margin-top: 4px;
}

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    background-color: #1a418c;
}

/* Basic Details Card Styles - Compact Mobile Layout */
.basic-details-body {
    padding: 10px 12px !important;
}

/* Profile Header - Outside Card Layout */
.profile-header-outside {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 16px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-bottom: 8px;
}

/* Profile Header - Inside Card Layout (for backward compatibility) */
.profile-header-compact {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e9ecef;
    margin-bottom: 8px;
}

.avatar-section-compact {
    flex-shrink: 0;
}

.profile-header-main {
    display: flex;
    align-items: center;
    gap: 8px;
}

.profile-avatar-compact {
    width: 44px;
    height: 44px;
    object-fit: cover;
    border: 2px solid #1a418c;
    border-radius: 50%;
}

.profile-header-outside .profile-avatar-compact {
    width: 56px;
    height: 56px;
}

.profile-info-compact {
    flex: 1;
    min-width: 0;
}

.profile-name-compact {
    font-size: 14px;
    font-weight: 600;
    color: #1a418c;
    margin-bottom: 0;
    line-height: 1.1;
    word-break: break-word;
}

.profile-header-outside .profile-name-compact {
    font-size: 16px;
    font-weight: 600;
    color: #27173E;
    line-height: 1.3;
}

.profile-mobile-compact {
    font-size: 12px;
    color: #6c757d;
    margin-bottom: 0;
}

.profile-header-outside .profile-mobile-compact {
    font-size: 14px;
    color: #8494A8;
    margin-top: 2px;
}

/* Reference ID: no gap below mobile, light red text */
.profile-reference-id-compact {
    margin-top: 0;
    line-height: 1.2;
}
.reference-id-light-red,
.reference-id-light-red span {
    color: #d65c5c !important;
}

.profile-header-outside .profile-header-main {
    gap: 12px;
}

.profile-status-compact {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;
    margin-top: 2px;
}

.badge-sm {
    font-size: 9px;
    padding: 2px 6px;
    font-weight: 500;
}

/* Compact Form Fields */
.compact-fields-row {
    margin: 0;
}

.compact-fields-row .col-6 {
    padding-left: 4px;
    padding-right: 4px;
}

.form-group-compact {
    margin-bottom: 6px;
}

.label-compact {
    font-size: 9px;
    font-weight: 500;
    margin-bottom: 2px;
    color: #1a418c;
    display: block;
    line-height: 1.2;
}

.form-control-compact {
    padding: 0;
    background-color: transparent;
    border: 0;
    border-radius: 0;
    min-height: auto;
    display: block;
    font-size: 11px;
    color: #495057;
    word-break: break-word;
    line-height: 1.3;
}

.form-control-compact.membership-status-field {
    justify-content: flex-start;
    gap: 4px;
    background-color: transparent;
    border: 0;
    padding-left: 0;
}

.suggest-edit-btn {
    padding: 0;
    margin: 0;
    color: #1a418c;
    font-size: 18px;
}

.membership-inline {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.membership-inline-value {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
}

.basic-inline-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 12px;
    row-gap: 4px;
}

/* Tighter spacing inside Basic Details card - less gap between rows and between icon/text */
.basic-details-body .basic-inline-grid {
    row-gap: 0;
}
.basic-details-body .form-group-compact {
    margin-bottom: 2px;
}
.basic-details-body .form-group-compact:last-child {
    margin-bottom: 0;
}
.basic-details-body .basic-inline {
    gap: 4px;
}

.basic-inline {
    display: flex;
    align-items: center;
    gap: 6px;
}

.basic-inline-full {
    grid-column: 1 / -1;
}

.basic-inline-icon {
    font-size: 16px;
    color: #1a418c;
    flex-shrink: 0;
}

.basic-inline-text {
    font-size: 14px;
    color: #495057;
    word-break: break-word;
    font-weight: 500;
    line-height: 1.2;
}

.membership-badge {
    display: inline-block;
    padding: 1px 6px;
    border-radius: 999px;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.2;
}

.membership-badge.text-success {
    background-color: #d1f2d8;
    color: #198754;
}

.membership-badge.text-danger {
    background-color: #f8d7da;
    color: #dc3545;
}

.profile-header-actions {
    display: flex;
    align-items: center;
    gap: 6px;
}

.header-call-btn,
.header-whatsapp-btn {
    padding: 0;
    margin: 0;
    font-size: 18px;
    color: #1a418c;
}

.header-whatsapp-btn {
    color: #25d366;
}

@media (max-width: 360px) {
    .basic-inline-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

/* Edit Basic Details Action Sheet Styles */
#editBasicDetailsModal.action-sheet .modal-content {
    border-radius: 16px 16px 0 0;
    background-color: #fff;
}

#editBasicDetailsModal.action-sheet .modal-header {
    padding: 10px 16px 8px;
    border-bottom: 1px solid #e9ecef;
    position: relative;
}

#editBasicDetailsModal.action-sheet .modal-header .modal-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    text-align: center;
    padding: 0;
    margin: 0;
}

#editBasicDetailsModal.action-sheet .close-button {
    position: absolute;
    right: 10px;
    top: 8px;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
    font-size: 18px;
    cursor: pointer;
    border: none;
    background: transparent;
    padding: 0;
}

#editBasicDetailsModal.action-sheet .close-button:hover {
    color: #333;
}

#editBasicDetailsModal.action-sheet .action-sheet-content {
    padding: 10px 16px;
    max-height: 60vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    background-color: #fff;
}

.edit-basic-form {
    margin: 0;
}

/* Use standard form-group.basic styling from DawaDirectory.vue */
#editBasicDetailsModal.action-sheet .form-group.basic {
    padding: 8px 0;
    margin-bottom: 12px;
}

#editBasicDetailsModal.action-sheet .form-group.basic:last-of-type {
    margin-bottom: 0;
}

#editBasicDetailsModal.action-sheet .form-group.basic .label {
    font-size: 11px;
    margin: 0;
    font-weight: 500;
    color: #27173E;
    display: block;
    line-height: 1.2em;
    text-align: left;
    margin-bottom: 4px;
}

#editBasicDetailsModal.action-sheet .form-group.basic .form-control,
#editBasicDetailsModal.action-sheet .form-group.basic .custom-select {
    background: transparent;
    border: none;
    border-bottom: 1px solid #DCDCE9;
    padding: 0 30px 0 0;
    border-radius: 0;
    height: 40px;
    color: #27173E;
    font-size: 15px;
    width: 100%;
}

#editBasicDetailsModal.action-sheet .form-group.basic .form-control:focus,
#editBasicDetailsModal.action-sheet .form-group.basic .custom-select:focus {
    border-bottom-color: #1a418c;
    box-shadow: inset 0 -1px 0 0 #1a418c;
    outline: none;
}

#editBasicDetailsModal.action-sheet .form-group.basic textarea.form-control {
    height: auto;
    padding: 7px 40px 7px 0;
    min-height: 60px;
    resize: vertical;
}

#editBasicDetailsModal.action-sheet .form-group.basic .custom-select {
    padding-right: 0;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%2327173E' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 0 center;
    cursor: pointer;
}

#editBasicDetailsModal.action-sheet .form-group.basic .form-control::placeholder {
    color: #A9ABAD;
    opacity: 1;
}

.edit-radio-group {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 0;
    margin-top: 2px;
}

.edit-radio-item {
    display: flex;
    align-items: center;
    padding: 6px 8px;
    border-radius: 6px;
    background-color: #f8f9fa;
    transition: background-color 0.2s ease;
}

.edit-radio-item:hover {
    background-color: #e9ecef;
}

.edit-radio-input {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    cursor: pointer;
    accent-color: #1a418c;
}

.edit-radio-label {
    margin: 0;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    flex: 1;
    line-height: 1.3;
}

.edit-form-actions {
    margin-top: 12px;
    padding-top: 0;
    border-top: none;
    display: flex;
    flex-direction: column;
}

/* Button styling now uses standard btn-primary btn-block btn-lg classes */


/* Mobile Responsive */
@media (max-width: 576px) {
    #editBasicDetailsModal.action-sheet .modal-header {
        padding: 8px 12px 6px;
    }
    
    #editBasicDetailsModal.action-sheet .modal-header .modal-title {
        font-size: 15px;
    }
    
    #editBasicDetailsModal.action-sheet .action-sheet-content {
        padding: 8px 12px;
        max-height: 65vh;
    }
    
    #editBasicDetailsModal.action-sheet .form-group.basic {
        margin-bottom: 10px;
    }
    
    #editBasicDetailsModal.action-sheet .form-group.basic .label {
        font-size: 11px;
        margin-bottom: 4px;
    }
    
    #editBasicDetailsModal.action-sheet .form-group.basic .form-control,
    #editBasicDetailsModal.action-sheet .form-group.basic .custom-select {
        font-size: 15px;
        height: 40px;
    }
    
    .edit-form-actions {
        margin-top: 10px;
        padding-top: 0;
    }
    
    .edit-radio-group {
        gap: 3px;
        padding: 0;
        margin-top: 2px;
    }
    
    .edit-radio-item {
        padding: 5px 6px;
    }
}

/* Desktop Responsive */
@media (min-width: 768px) {
    #editBasicDetailsModal.action-sheet .action-sheet-content {
        padding: 12px 18px;
        max-height: 55vh;
    }
    
    .edit-form-group {
        margin-bottom: 0;
        padding: 0;
    }
}

/* Tablet Responsive */
@media (min-width: 577px) and (max-width: 767px) {
    #editBasicDetailsModal.action-sheet .action-sheet-content {
        padding: 10px 16px;
        max-height: 60vh;
    }
}

/* Call History Styles */
.call-history-card {
    padding: 10px 12px;
}

.call-history-header {
    margin-bottom: 6px;
}

.call-history-title {
    font-size: 13px;
    font-weight: 600;
    color: #1a418c;
}

.call-history-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.call-history-item {
    display: flex;
    align-items: flex-start;
    font-size: 12px;
    color: #495057;
}

.call-history-item + .call-history-item {
    margin-top: 4px;
}

.call-history-timeline {
    position: relative;
    width: 16px;
    display: flex;
    justify-content: center;
}

.call-history-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #ced4da;
    margin-top: 4px;
}

.call-history-dot.active {
    width: 8px;
    height: 8px;
    background-color: #1a418c;
}

.call-history-line {
    position: absolute;
    top: 10px;
    bottom: -6px;
    left: 50%;
    width: 2px;
    transform: translateX(-50%);
    background-color: #e9ecef;
}

.call-history-content {
    flex: 1;
    padding-left: 4px;
}

.call-history-entry {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 6px 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.call-history-entry-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    margin-bottom: 4px;
}

.call-history-main {
    font-weight: 500;
    color: #212529;
}

.call-history-duration {
    font-size: 11px;
    color: #868e96;
    white-space: nowrap;
}

.call-history-chevron {
    font-size: 14px;
    color: #adb5bd;
}

.call-history-meta {
    font-size: 11px;
    color: #868e96;
    margin-bottom: 2px;
}

.call-history-meta .dot-separator::before {
    content: "• ";
    margin: 0 2px 0 4px;
}

.call-history-section {
    font-size: 11px;
    color: #495057;
}

.call-history-section + .call-history-section {
    margin-top: 2px;
}

.call-history-section-label {
    font-weight: 500;
    margin-right: 2px;
}

.call-history-section-text {
    color: #495057;
}

/* Detail Tabs spacing to align with cards */
.detail-tabs-wrapper {
    padding-left: 8px;
    padding-right: 8px;
}

.detail-tabs {
    margin-left: 4px;
    margin-right: 4px;
}

/* Non-clickable items when viewing from report */
.not-clickable {
    cursor: default !important;
    pointer-events: none;
    opacity: 0.8;
}

.not-clickable:hover {
    background-color: inherit !important;
}

/* Mobile Optimizations */
@media (max-width: 576px) {
    .basic-details-body {
        padding: 8px 10px !important;
    }
    
    .profile-header-compact {
        gap: 6px;
        padding-bottom: 6px;
        margin-bottom: 6px;
    }
    
    .profile-avatar-compact {
        width: 40px;
        height: 40px;
    }
    
    .profile-name-compact {
        font-size: 15px;
    }
    
    .profile-mobile-compact {
        font-size: 14px;
    }
    
    .compact-fields-row .col-6 {
        padding-left: 3px;
        padding-right: 3px;
    }
    
    .form-group-compact {
        margin-bottom: 5px;
    }
    
    .label-compact {
        font-size: 8px;
    }
    
    .form-control-compact {
        font-size: 10px;
        padding: 2px 5px;
        min-height: 22px;
    }
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section {
    position: relative;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.avatar-section .button-payment {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 5px;
    bottom: 0;
}

.avatar-section .payment-verified {
    background: #05d0a4;
}

.green-tick {
    font-size: 18px;
    color: darkgreen;
}

.red-cross {
    font-size: 18px;
    color: red;
}

.qhls-text {
    font-style: italic;
    color: #266bd1;
}

.custom-file-upload {
    position: relative;
    display: flex;
    width: 50%;
    height: 100px;
}

.radio-group,
.checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 5px;
}

.form-check {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 0;
    padding: 0;
}

.form-check-input {
    margin: 0 !important;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
}

.form-check-label {
    margin: 0 !important;
    padding: 0;
    font-weight: normal;
    cursor: pointer;
    user-select: none;
}

.activity-tracking-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 6px 8px;
}

.activity-tracking-row .form-check-label {
    display: inline-flex;
    align-items: flex-start;
    gap: 6px;
    flex: 0 0 calc(50% - 8px); /* 2 items per row, mobile-friendly */
    max-width: calc(50% - 8px);
    min-width: 0;
}

.activity-tracking-row .form-check-input {
    margin-top: 2px !important; /* vertically align with first line of text */
}

.activity-tracking-row .form-check-label span {
    display: block;
    line-height: 1.2;
    white-space: normal;
    word-break: break-word;
}

/* For horizontal layout on larger screens */
@media (min-width: 576px) {
    .radio-group,
    .checkbox-group {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 15px;
    }

    .form-check {
        margin-right: 15px;
        margin-bottom: 8px;
    }
}

.custom-select {
    appearance: auto;
    -webkit-appearance: auto;
    -moz-appearance: auto;
}

.compact-item {
    min-height: 50px !important;
    padding: 8px 15px !important;
}

.compact-item .detail {
    align-items: center;
}

.compact-item .detail img {
    width: 32px !important;
    height: 32px !important;
    margin-right: 12px;
}

.compact-item .detail div {
    display: flex;
    align-items: center;
}

/* Status Badges Styles */
.status-badges-container {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 4px;
    align-items: center;
}

.status-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.2;
}

.status-badge ion-icon {
    font-size: 14px;
    flex-shrink: 0;
}

/* Registration Status Styles */
.status-badge-registered {
    background-color: #d1f2d8;
    color: #198754;
    border: 1px solid #198754;
}

.status-badge-registered ion-icon {
    color: #198754;
}

.status-badge-unregistered {
    background-color: #fff3cd;
    color: #ff9800;
    border: 1px solid #ff9800;
}

.status-badge-unregistered ion-icon {
    color: #dc3545;
}

/* Self Confirmation Status Styles */
.status-badge-confirmed {
    background-color: #cfe2ff;
    color: #0d6efd;
    border: 1px solid #0d6efd;
}

.status-badge-confirmed ion-icon {
    color: #0d6efd;
}

.status-badge-not-confirmed {
    background-color: #f8d7da;
    color: #dc3545;
    border: 1px solid #dc3545;
}

.status-badge-not-confirmed ion-icon {
    color: #dc3545;
}

/* Payment Status Styles */
.status-badge-paid {
    background-color: #d1f2d8;
    color: #198754;
    border: 1px solid #198754;
}

.status-badge-paid ion-icon {
    color: #198754;
}

.status-badge-unpaid {
    background-color: #f8d7da;
    color: #dc3545;
    border: 1px solid #dc3545;
}

.status-badge-unpaid ion-icon {
    color: #dc3545;
}

.status-badge-default {
    background-color: #e9ecef;
    color: #6c757d;
    border: 1px solid #6c757d;
}

.status-badge-default ion-icon {
    color: #6c757d;
}

/* Mobile Responsive for Status Badges */
@media (max-width: 576px) {
    .status-badges-container {
        gap: 4px;
        margin-bottom: 3px;
    }
    
    .status-badge {
        padding: 3px 6px;
        font-size: 11px;
        border-radius: 10px;
    }
    
    .status-badge ion-icon {
        font-size: 12px;
    }
}

/* Value Differences Section */
.value-differences-section {
    border-top: 1px solid #e9ecef;
    padding-top: 10px;
}

.diff-header {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
}

.diff-header-clickable {
    cursor: pointer;
    user-select: none;
    padding: 4px 0;
}
.diff-header-clickable:hover {
    opacity: 0.85;
}

.diff-header-chevron {
    font-size: 18px;
    color: #666;
    margin-left: auto;
}

.diff-header-icon {
    font-size: 16px;
    color: #f0ad4e;
}

.diff-header-text {
    font-size: 13px;
    font-weight: 600;
    color: #555;
}

.diff-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.diff-item {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 8px 10px;
    border-left: 3px solid #f0ad4e;
}

.diff-field-name {
    font-size: 11px;
    font-weight: 600;
    color: #666;
    text-transform: uppercase;
    margin-bottom: 4px;
}

.diff-values {
    display: flex;
    flex-direction: column;
}

.diff-value-row {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
}

.diff-source-label {
    font-size: 11px;
    font-weight: 500;
    color: #888;
    min-width: 80px;
}

.diff-value {
    font-weight: 500;
}

.diff-indicator {
    display: inline-flex;
    align-items: center;
    margin-left: 4px;
    cursor: help;
}

/* Diff Selector in Edit Form */
.diff-selector {
    background: #fff8e6;
    border: 1px solid #f0ad4e;
    border-radius: 8px;
    padding: 8px 10px;
    margin-bottom: 6px;
}

.diff-selector-header {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 6px;
}

.diff-selector-text {
    font-size: 11px;
    font-weight: 500;
    color: #856404;
}

.diff-selector-options {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.diff-option {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 8px;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.2s;
    font-size: 13px;
    border: 1px solid transparent;
    background: #fff;
    margin: 0;
}

.diff-option:hover {
    background: #f0f0f0;
}

.diff-option.selected {
    background: #e8f4fd;
    border-color: #1a418c;
}

.diff-option input[type="radio"] {
    margin: 0;
    flex-shrink: 0;
}

.diff-option-label {
    font-size: 11px;
    font-weight: 500;
    color: #888;
    min-width: 75px;
}

.diff-option-value {
    font-weight: 500;
    word-break: break-word;
}
</style>

